/* ???? FINDER SCRIPT ???? */

const answers={};
const TOTAL=12;

/* DB-Version kommt aus finder2-db.js (window.FINDER_DB_VERSION) */
const DB_VERSION = window.FINDER_DB_VERSION || 'unknown';

/* Auto-Reset: localStorage leeren wenn Version nicht uebereinstimmt */
(function(){
  try {
    const storedVersion = localStorage.getItem('fp_db_version');
    if (storedVersion !== DB_VERSION) {
      localStorage.removeItem('fp_dive_computers');
      localStorage.removeItem('fp_admin_db');
      localStorage.setItem('fp_db_version', DB_VERSION);
    }
  } catch(e) {}
})();

/* Fragen-Titelbilder - fest eingebaut */
const Q_KEYS = ['budget','style','fmt','display','gas','airInt','battery','connect','compass','gps','logbook','upd'];
const MULTI_KEYS = ['style','gas']; // Mehrfachauswahl erlaubt
const QUESTION_IMAGES = {
  budget:  'https://cdn.shopify.com/s/files/1/0798/1921/1086/files/1.jpg?v=1778953107',
  style:   'https://cdn.shopify.com/s/files/1/0798/1921/1086/files/2.jpg?v=1778953112',
  fmt:     'https://cdn.shopify.com/s/files/1/0798/1921/1086/files/3.jpg?v=1778953113',
  display: 'https://cdn.shopify.com/s/files/1/0798/1921/1086/files/4.jpg?v=1778953113',
  gas:     'https://cdn.shopify.com/s/files/1/0798/1921/1086/files/5.jpg?v=1778953108',
  airInt:  'https://cdn.shopify.com/s/files/1/0798/1921/1086/files/6.jpg?v=1778953111',
  battery: 'https://cdn.shopify.com/s/files/1/0798/1921/1086/files/7.jpg?v=1778953109',
  connect: 'https://cdn.shopify.com/s/files/1/0798/1921/1086/files/8.jpg?v=1778953111',
  compass: 'https://cdn.shopify.com/s/files/1/0798/1921/1086/files/Kompass.jpg?v=1779044497',
  gps:     'https://cdn.shopify.com/s/files/1/0798/1921/1086/files/GPS.jpg?v=1779044513',
  logbook: 'https://cdn.shopify.com/s/files/1/0798/1921/1086/files/9.jpg?v=1778953106',
  upd:     'https://cdn.shopify.com/s/files/1/0798/1921/1086/files/10.png?v=1778953114',
};
let lang='de';

/* ILLUSTRATED SVG ART per option key */
const ART = {
  /* Budget */
  'budget:<250': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="20" width="64" height="42" rx="8" fill="#B5D4F4" stroke="#185FA5" stroke-width="2"/><rect x="8" y="34" width="64" height="10" fill="#185FA5" opacity=".25"/><rect x="14" y="40" width="20" height="12" rx="4" fill="#185FA5" opacity=".35"/><circle cx="54" cy="52" r="7" fill="#185FA5" opacity=".5"/><circle cx="44" cy="52" r="7" fill="#185FA5" opacity=".3"/><text x="40" y="16" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="700" fill="#185FA5">&#x20AC;</text></svg>`,
  'budget:250-500': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="6" y="20" width="68" height="42" rx="8" fill="#9FE1CB" stroke="#0F6E56" stroke-width="2"/><rect x="6" y="34" width="68" height="10" fill="#0F6E56" opacity=".25"/><rect x="12" y="40" width="18" height="12" rx="4" fill="#0F6E56" opacity=".35"/><circle cx="54" cy="52" r="7" fill="#0F6E56" opacity=".5"/><circle cx="43" cy="52" r="7" fill="#0F6E56" opacity=".4"/><circle cx="32" cy="52" r="7" fill="#0F6E56" opacity=".25"/><text x="40" y="16" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="700" fill="#0F6E56">&#x20AC;&#x20AC;</text></svg>`,
  'budget:500-900': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="20" width="72" height="42" rx="8" fill="#FAC775" stroke="#854F0B" stroke-width="2"/><rect x="4" y="34" width="72" height="10" fill="#854F0B" opacity=".25"/><rect x="10" y="40" width="16" height="12" rx="4" fill="#854F0B" opacity=".35"/><circle cx="58" cy="52" r="7" fill="#854F0B" opacity=".5"/><circle cx="47" cy="52" r="7" fill="#854F0B" opacity=".45"/><circle cx="36" cy="52" r="7" fill="#854F0B" opacity=".35"/><circle cx="25" cy="52" r="7" fill="#854F0B" opacity=".2"/><text x="40" y="16" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="700" fill="#854F0B">&#x20AC;&#x20AC;&#x20AC;</text></svg>`,
  'budget:>900': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><polygon points="40,6 48,28 72,28 54,44 62,68 40,52 18,68 26,44 8,28 32,28" fill="#F09595" stroke="#A32D2D" stroke-width="2" stroke-linejoin="round"/><polygon points="40,14 46,30 62,30 50,40 55,56 40,46 25,56 30,40 18,30 34,30" fill="#E24B4A" opacity=".5"/><text x="40" y="76" text-anchor="middle" font-family="sans-serif" font-size="11" font-weight="700" fill="#A32D2D">Pro</text></svg>`,

  /* Style */
  'style:rec': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="40" cy="50" rx="30" ry="10" fill="#B5D4F4" opacity=".4"/><circle cx="40" cy="26" r="12" fill="#B5D4F4" stroke="#185FA5" stroke-width="2.5"/><path d="M28 26h24M40 14v24" stroke="#185FA5" stroke-width="2" stroke-linecap="round"/><path d="M16 48 Q40 34 64 48" stroke="#185FA5" stroke-width="2.5" fill="none" stroke-linecap="round"/><path d="M10 56 Q40 40 70 56" stroke="#185FA5" stroke-width="1.5" fill="none" stroke-linecap="round" opacity=".4"/></svg>`,
  'style:cold': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M40 8v64M8 40h64M14 14l52 52M66 14 14 66" stroke="#85B7EB" stroke-width="2.5" stroke-linecap="round"/><circle cx="40" cy="40" r="10" fill="#E6F1FB" stroke="#185FA5" stroke-width="2.5"/><circle cx="40" cy="8" r="4" fill="#185FA5"/><circle cx="40" cy="72" r="4" fill="#185FA5"/><circle cx="8" cy="40" r="4" fill="#185FA5"/><circle cx="72" cy="40" r="4" fill="#185FA5"/><circle cx="14" cy="14" r="3" fill="#378ADD" opacity=".6"/><circle cx="66" cy="14" r="3" fill="#378ADD" opacity=".6"/><circle cx="14" cy="66" r="3" fill="#378ADD" opacity=".6"/><circle cx="66" cy="66" r="3" fill="#378ADD" opacity=".6"/></svg>`,
  'style:tech': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="12" y="38" width="16" height="30" rx="5" fill="#AFA9EC" stroke="#534AB7" stroke-width="2"/><rect x="52" y="38" width="16" height="30" rx="5" fill="#AFA9EC" stroke="#534AB7" stroke-width="2"/><path d="M28 46h24M28 58h24" stroke="#534AB7" stroke-width="1.8" stroke-dasharray="3 2"/><rect x="28" y="18" width="24" height="34" rx="5" fill="#CECBF6" stroke="#534AB7" stroke-width="2"/><path d="M36 28v14M44 28v14" stroke="#534AB7" stroke-width="2" stroke-linecap="round"/><path d="M33 18v-7M47 18v-7" stroke="#7F77DD" stroke-width="2" stroke-linecap="round"/><circle cx="33" cy="9" r="3" fill="#534AB7"/><circle cx="47" cy="9" r="3" fill="#534AB7"/></svg>`,
  'style:ccr': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="16" y="14" width="18" height="46" rx="7" fill="#9FE1CB" stroke="#0F6E56" stroke-width="2"/><rect x="46" y="14" width="18" height="46" rx="7" fill="#5DCAA5" opacity=".5" stroke="#0F6E56" stroke-width="2"/><path d="M34 28 Q40 37 46 28" stroke="#0F6E56" stroke-width="2.5" fill="none" stroke-linecap="round"/><path d="M34 48 Q40 57 46 48" stroke="#0F6E56" stroke-width="2.5" fill="none" stroke-linecap="round"/><circle cx="40" cy="8" r="5" fill="#0F6E56" opacity=".6"/><path d="M40 13v5" stroke="#0F6E56" stroke-width="2" stroke-linecap="round"/><text x="40" y="75" text-anchor="middle" font-family="sans-serif" font-size="9" font-weight="700" fill="#0F6E56">CCR</text></svg>`,
  'style:apnea': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M40 6 Q56 24 40 40 Q24 56 40 74" stroke="#5DCAA5" stroke-width="4" fill="none" stroke-linecap="round"/><path d="M24 14 Q40 20 40 40" stroke="#9FE1CB" stroke-width="1.8" fill="none" stroke-linecap="round"/><path d="M56 14 Q40 20 40 40" stroke="#9FE1CB" stroke-width="1.8" fill="none" stroke-linecap="round"/><circle cx="40" cy="40" r="8" fill="#1D9E75" opacity=".3"/><circle cx="40" cy="40" r="4" fill="#0F6E56" opacity=".6"/></svg>`,

  /* Format */
  'fmt:wrist-large': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="26" y="6" width="28" height="8" rx="4" fill="#888780" opacity=".5"/><rect x="26" y="66" width="28" height="8" rx="4" fill="#888780" opacity=".5"/><rect x="14" y="14" width="52" height="52" rx="12" fill="#D3D1C7" stroke="#5F5E5A" stroke-width="2.5"/><rect x="20" y="20" width="40" height="40" rx="8" fill="#2C2C2A"/><text x="40" y="38" text-anchor="middle" font-family="monospace" font-size="11" font-weight="700" fill="#4A90D9">18.4</text><text x="40" y="50" text-anchor="middle" font-family="monospace" font-size="7" fill="#9FE1CB">m  47min</text></svg>`,
  'fmt:wrist-watch': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="30" y="4" width="20" height="8" rx="4" fill="#888780" opacity=".5"/><rect x="30" y="68" width="20" height="8" rx="4" fill="#888780" opacity=".5"/><rect x="18" y="12" width="44" height="56" rx="16" fill="#B4B2A9" stroke="#5F5E5A" stroke-width="2.5"/><rect x="24" y="18" width="32" height="44" rx="12" fill="#2C2C2A"/><circle cx="40" cy="40" r="14" stroke="#378ADD" stroke-width="1.5" fill="none" opacity=".4"/><text x="40" y="37" text-anchor="middle" font-family="monospace" font-size="9" font-weight="700" fill="#fff">18.4</text><text x="40" y="47" text-anchor="middle" font-family="monospace" font-size="6" fill="#9FE1CB">m</text></svg>`,
  'fmt:console': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="20" width="44" height="44" rx="8" fill="#D3D1C7" stroke="#5F5E5A" stroke-width="2.5"/><rect x="16" y="26" width="32" height="32" rx="5" fill="#2C2C2A"/><text x="32" y="44" text-anchor="middle" font-family="monospace" font-size="9" font-weight="700" fill="#4A90D9">18.4</text><text x="32" y="52" text-anchor="middle" font-family="monospace" font-size="6" fill="#9FE1CB">m</text><path d="M54 42 Q68 42 68 30" stroke="#5F5E5A" stroke-width="3" fill="none" stroke-linecap="round"/><circle cx="68" cy="28" r="5" fill="#5F5E5A" opacity=".6"/></svg>`,
  'fmt:any': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="6" y="24" width="30" height="22" rx="6" fill="#B5D4F4" stroke="#185FA5" stroke-width="1.8"/><rect x="10" y="28" width="22" height="14" rx="3" fill="#2C2C2A"/><text x="21" y="37" text-anchor="middle" font-family="monospace" font-size="7" fill="#4A90D9">18m</text><rect x="44" y="16" width="22" height="38" rx="8" fill="#9FE1CB" stroke="#0F6E56" stroke-width="1.8"/><rect x="48" y="20" width="14" height="30" rx="5" fill="#2C2C2A"/><text x="55" y="37" text-anchor="middle" font-family="monospace" font-size="7" fill="#4A90D9">18m</text><text x="40" y="72" text-anchor="middle" font-family="sans-serif" font-size="9" fill="#5F5E5A" opacity=".7">egal</text></svg>`,

  /* Display */
  'display:color-large': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="6" y="14" width="68" height="44" rx="7" fill="#1A3759"/><rect x="10" y="18" width="60" height="36" rx="4" fill="#0D0D0D"/><rect x="13" y="21" width="16" height="10" rx="2" fill="#E24B4A" opacity=".9"/><rect x="32" y="21" width="16" height="10" rx="2" fill="#4CAF7D" opacity=".9"/><rect x="51" y="21" width="16" height="10" rx="2" fill="#378ADD" opacity=".9"/><rect x="13" y="33" width="54" height="4" rx="1" fill="#fff" opacity=".1"/><text x="40" y="46" text-anchor="middle" font-family="monospace" font-size="10" font-weight="700" fill="#378ADD">18.4 m</text><path x="34" y="62" d="M32 62h16" stroke="#5A6E87" stroke-width="3" stroke-linecap="round"/><path d="M40 58v4" stroke="#5A6E87" stroke-width="3" stroke-linecap="round"/></svg>`,
  'display:color-watch': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="28" y="4" width="24" height="7" rx="3" fill="#888780" opacity=".5"/><rect x="28" y="69" width="24" height="7" rx="3" fill="#888780" opacity=".5"/><rect x="18" y="11" width="44" height="58" rx="14" fill="#1A3759"/><rect x="22" y="15" width="36" height="50" rx="10" fill="#0D0D0D"/><rect x="26" y="19" width="12" height="8" rx="2" fill="#E24B4A" opacity=".85"/><rect x="42" y="19" width="12" height="8" rx="2" fill="#378ADD" opacity=".85"/><text x="40" y="38" text-anchor="middle" font-family="monospace" font-size="11" font-weight="700" fill="#fff">18.4</text><text x="40" y="50" text-anchor="middle" font-family="monospace" font-size="7" fill="#378ADD">m  47min</text></svg>`,
  'display:mono': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="6" y="14" width="68" height="44" rx="7" fill="#444441"/><rect x="10" y="18" width="60" height="36" rx="4" fill="#C8D8B0"/><text x="40" y="34" text-anchor="middle" font-family="monospace" font-size="13" font-weight="700" fill="#0D0D0D">18.4</text><text x="40" y="44" text-anchor="middle" font-family="monospace" font-size="7" fill="#2C3A20">m   47min  NDL22</text><path d="M10" y="48" d="M10 48h60" stroke="#2C3A20" stroke-width="0.8" opacity=".3"/><path d="M32 62h16" stroke="#5A6E87" stroke-width="3" stroke-linecap="round"/><path d="M40 58v4" stroke="#5A6E87" stroke-width="3" stroke-linecap="round"/></svg>`,
  'display:any': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="18" width="36" height="24" rx="5" fill="#B5D4F4" stroke="#185FA5" stroke-width="1.8"/><rect x="8" y="22" width="28" height="16" rx="3" fill="#0D0D0D"/><text x="22" y="32" text-anchor="middle" font-family="monospace" font-size="8" font-weight="700" fill="#378ADD">18m</text><rect x="48" y="10" width="28" height="46" rx="10" fill="#9FE1CB" stroke="#0F6E56" stroke-width="1.8"/><rect x="52" y="14" width="20" height="38" rx="7" fill="#0D0D0D"/><text x="62" y="35" text-anchor="middle" font-family="monospace" font-size="8" font-weight="700" fill="#4CAF7D">18m</text></svg>`,

  /* Gas */
  'gas:air': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="26" y="12" width="28" height="52" rx="10" fill="#B5D4F4" stroke="#185FA5" stroke-width="2.5"/><rect x="32" y="7" width="16" height="7" rx="3" fill="#185FA5" opacity=".7"/><rect x="31" y="16" width="18" height="30" rx="5" fill="#185FA5" opacity=".15"/><text x="40" y="36" text-anchor="middle" font-family="sans-serif" font-size="10" font-weight="700" fill="#185FA5">AIR</text><path d="M54 28 Q66 34 54 42" stroke="#185FA5" stroke-width="2" fill="none" stroke-dasharray="3 2" opacity=".7"/><path d="M54 35 Q72 35 66 22" stroke="#185FA5" stroke-width="1.5" fill="none" opacity=".4"/></svg>`,
  'gas:nitrox': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="12" width="26" height="52" rx="9" fill="#B5D4F4" stroke="#185FA5" stroke-width="2.5"/><rect x="44" y="12" width="26" height="52" rx="9" fill="#C0DD97" stroke="#3B6D11" stroke-width="2.5"/><rect x="16" y="8" width="14" height="7" rx="3" fill="#185FA5" opacity=".7"/><rect x="50" y="8" width="14" height="7" rx="3" fill="#3B6D11" opacity=".7"/><text x="23" y="42" text-anchor="middle" font-family="sans-serif" font-size="9" font-weight="700" fill="#185FA5">N2</text><text x="57" y="42" text-anchor="middle" font-family="sans-serif" font-size="9" font-weight="700" fill="#3B6D11">O2</text><text x="40" y="75" text-anchor="middle" font-family="sans-serif" font-size="8" font-weight="600" fill="#3C4C63" opacity=".7">EAN 32</text></svg>`,
  'gas:trimix': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="16" width="20" height="48" rx="7" fill="#B5D4F4" stroke="#185FA5" stroke-width="2"/><rect x="30" y="16" width="20" height="48" rx="7" fill="#C0DD97" stroke="#3B6D11" stroke-width="2"/><rect x="56" y="16" width="20" height="48" rx="7" fill="#FAC775" stroke="#854F0B" stroke-width="2"/><text x="14" y="42" text-anchor="middle" font-family="sans-serif" font-size="8" font-weight="700" fill="#185FA5">N2</text><text x="40" y="42" text-anchor="middle" font-family="sans-serif" font-size="8" font-weight="700" fill="#3B6D11">O2</text><text x="66" y="42" text-anchor="middle" font-family="sans-serif" font-size="8" font-weight="700" fill="#854F0B">He</text><text x="40" y="76" text-anchor="middle" font-family="sans-serif" font-size="8" font-weight="600" fill="#3C4C63" opacity=".7">Trimix</text></svg>`,
  'gas:ccr-gas': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M40 8 Q62 40 40 72 Q18 40 40 8Z" fill="#CECBF6" stroke="#534AB7" stroke-width="2.5"/><circle cx="40" cy="40" r="14" fill="#7F77DD" opacity=".35"/><path d="M40 26 Q52 40 40 54 Q28 40 40 26Z" fill="#534AB7" opacity=".6"/><text x="40" y="75" text-anchor="middle" font-family="sans-serif" font-size="9" font-weight="700" fill="#534AB7">CCR O2</text></svg>`,

  /* Air integration */
  'airInt:must': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="24" y="8" width="28" height="46" rx="8" fill="#B5D4F4" stroke="#185FA5" stroke-width="2.5"/><rect x="30" y="4" width="16" height="7" rx="3" fill="#185FA5" opacity=".7"/><rect x="28" y="14" width="20" height="32" rx="5" fill="#185FA5" opacity=".12"/><text x="38" y="34" text-anchor="middle" font-family="monospace" font-size="10" font-weight="700" fill="#185FA5">210</text><text x="38" y="44" text-anchor="middle" font-family="monospace" font-size="7" fill="#378ADD">bar</text><path d="M52 24 Q66 20 62 36" stroke="#185FA5" stroke-width="2" fill="none" stroke-dasharray="3 2"/><circle cx="62" cy="38" r="4" fill="#185FA5" opacity=".5"/><path d="M14 62 Q38 54 62 62" stroke="#185FA5" stroke-width="2.5" fill="none" stroke-linecap="round"/><rect x="26" y="58" width="24" height="8" rx="3" fill="#B5D4F4" stroke="#185FA5" stroke-width="1.5"/></svg>`,
  'airInt:nice': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="24" y="8" width="28" height="46" rx="8" fill="#E6F1FB" stroke="#378ADD" stroke-width="2" stroke-dasharray="4 3"/><text x="38" y="38" text-anchor="middle" font-family="monospace" font-size="18" font-weight="700" fill="#378ADD" opacity=".5">?</text><path d="M30 62h20" stroke="#378ADD" stroke-width="2.5" stroke-linecap="round"/><text x="40" y="75" text-anchor="middle" font-family="sans-serif" font-size="9" fill="#378ADD">optional</text></svg>`,
  'airInt:no': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="10" width="24" height="40" rx="8" fill="#D3D1C7" stroke="#5F5E5A" stroke-width="2.5"/><rect x="14" y="6" width="12" height="7" rx="3" fill="#5F5E5A" opacity=".7"/><text x="20" y="33" text-anchor="middle" font-family="monospace" font-size="8" font-weight="700" fill="#444441">bar</text><path d="M32 38 L48 54" stroke="#888780" stroke-width="2"/><rect x="44" y="50" width="30" height="22" rx="5" fill="#D3D1C7" stroke="#5F5E5A" stroke-width="2"/><path d="M50 58h18M50 64h12" stroke="#5F5E5A" stroke-width="1.5" stroke-linecap="round" opacity=".6"/><text x="59" y="70" text-anchor="middle" font-family="sans-serif" font-size="6" fill="#5F5E5A">SPG</text></svg>`,

  /* Battery */
  'battery:usb': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="20" width="38" height="24" rx="5" fill="#9FE1CB" stroke="#0F6E56" stroke-width="2.5"/><rect x="48" y="28" width="6" height="8" rx="2" fill="#0F6E56" opacity=".5"/><rect x="14" y="24" width="30" height="16" rx="3" fill="#0F6E56" opacity=".7"/><path d="M32 44 L32 56 L50 56" stroke="#0F6E56" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/><rect x="46" y="50" width="24" height="16" rx="5" fill="#9FE1CB" stroke="#0F6E56" stroke-width="2.5"/><path d="M52 58h12M58 54v8" stroke="#0F6E56" stroke-width="2" stroke-linecap="round"/></svg>`,
  'battery:replaceable': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="22" width="38" height="24" rx="5" fill="#FAC775" stroke="#854F0B" stroke-width="2.5"/><rect x="46" y="30" width="6" height="8" rx="2" fill="#854F0B" opacity=".5"/><rect x="12" y="26" width="14" height="16" rx="3" fill="#854F0B" opacity=".7"/><rect x="28" y="26" width="14" height="16" rx="3" fill="#854F0B" opacity=".35"/><path d="M54 52 Q62 40 70 52" stroke="#854F0B" stroke-width="2.5" fill="none" stroke-linecap="round"/><circle cx="62" cy="52" r="4" fill="#854F0B" opacity=".6"/><text x="62" y="70" text-anchor="middle" font-family="sans-serif" font-size="10" font-weight="700" fill="#854F0B">AA</text></svg>`,
  'battery:any': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="26" width="28" height="18" rx="5" fill="#B5D4F4" stroke="#185FA5" stroke-width="2"/><rect x="32" y="31" width="4" height="8" rx="2" fill="#185FA5" opacity=".5"/><rect x="8" y="30" width="20" height="10" rx="2" fill="#185FA5" opacity=".6"/><rect x="48" y="26" width="28" height="18" rx="5" fill="#FAC775" stroke="#854F0B" stroke-width="2"/><rect x="76" y="31" width="4" height="8" rx="2" fill="#854F0B" opacity=".5"/><rect x="52" y="30" width="10" height="10" rx="2" fill="#854F0B" opacity=".6"/><rect x="64" y="30" width="10" height="10" rx="2" fill="#854F0B" opacity=".3"/><text x="40" y="60" text-anchor="middle" font-size="20" fill="#3C4C63" opacity=".4">/</text><text x="40" y="74" text-anchor="middle" font-family="sans-serif" font-size="9" fill="#5F5E5A">egal</text></svg>`,

  /* Connectivity */
  'connect:high': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 38 Q40 12 76 38" stroke="#B5D4F4" stroke-width="3" fill="none" stroke-linecap="round"/><path d="M12 46 Q40 22 68 46" stroke="#85B7EB" stroke-width="3" fill="none" stroke-linecap="round"/><path d="M20 54 Q40 32 60 54" stroke="#378ADD" stroke-width="3" fill="none" stroke-linecap="round"/><path d="M28 62 Q40 44 52 62" stroke="#185FA5" stroke-width="3.5" fill="none" stroke-linecap="round"/><circle cx="40" cy="68" r="5" fill="#185FA5"/><rect x="28" y="6" width="24" height="16" rx="5" fill="#B5D4F4" stroke="#185FA5" stroke-width="2"/><circle cx="40" cy="14" r="4" fill="#185FA5" opacity=".6"/></svg>`,
  'connect:mid': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 38 Q40 12 76 38" stroke="#D3D1C7" stroke-width="3" fill="none" stroke-linecap="round"/><path d="M12 46 Q40 22 68 46" stroke="#B4B2A9" stroke-width="3" fill="none" stroke-linecap="round"/><path d="M20 54 Q40 32 60 54" stroke="#378ADD" stroke-width="3" fill="none" stroke-linecap="round"/><path d="M28 62 Q40 44 52 62" stroke="#185FA5" stroke-width="3.5" fill="none" stroke-linecap="round"/><circle cx="40" cy="68" r="5" fill="#185FA5"/></svg>`,
  'connect:low': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 38 Q40 12 76 38" stroke="#D3D1C7" stroke-width="3" fill="none" stroke-linecap="round" opacity=".3"/><path d="M12 46 Q40 22 68 46" stroke="#D3D1C7" stroke-width="3" fill="none" stroke-linecap="round" opacity=".3"/><path d="M20 54 Q40 32 60 54" stroke="#D3D1C7" stroke-width="3" fill="none" stroke-linecap="round" opacity=".3"/><path d="M28 62 Q40 44 52 62" stroke="#5F5E5A" stroke-width="3.5" fill="none" stroke-linecap="round"/><circle cx="40" cy="68" r="5" fill="#5F5E5A"/><rect x="22" y="12" width="36" height="22" rx="5" fill="#FAC775" stroke="#854F0B" stroke-width="2"/><path d="M28 20h24M28 26h16" stroke="#854F0B" stroke-width="2" stroke-linecap="round" opacity=".7"/><text x="40" y="74" text-anchor="middle" font-family="sans-serif" font-size="8" fill="#854F0B">USB</text></svg>`,

  /* Logbook */
  'logbook:power': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="38" width="60" height="34" rx="6" fill="#CECBF6" stroke="#534AB7" stroke-width="2.5"/><rect x="16" y="44" width="48" height="22" rx="3" fill="#1A3759"/><path d="M20 50h40M20 56h30M20 62h36" stroke="#7F77DD" stroke-width="1.5" opacity=".8" stroke-linecap="round"/><rect x="8" y="30" width="64" height="6" rx="3" fill="#534AB7" opacity=".25"/><path d="M18 8 L18 30M28 14 L28 30M40 10 L40 30M52 6 L52 30M62 16 L62 30" stroke="#7F77DD" stroke-width="3" stroke-linecap="round"/><path d="M10 30 Q28 18 40 22 Q52 26 70 12" stroke="#534AB7" stroke-width="2" fill="none" opacity=".5"/></svg>`,
  'logbook:casual': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="16" y="8" width="44" height="56" rx="6" fill="#E6F1FB" stroke="#185FA5" stroke-width="2.5"/><path d="M24 22h32M24 32h26M24 42h28M24 52h18" stroke="#185FA5" stroke-width="2" stroke-linecap="round" opacity=".6"/><rect x="24" y="14" width="10" height="10" rx="2" fill="#B5D4F4" stroke="#185FA5" stroke-width="1.5"/><circle cx="54" cy="58" r="12" fill="#9FE1CB" stroke="#0F6E56" stroke-width="2"/><path d="M50 58l3 3 6-6" stroke="#0F6E56" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  'logbook:none': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="16" y="10" width="44" height="46" rx="6" fill="#F1EFE8" stroke="#888780" stroke-width="2.5"/><rect x="22" y="16" width="32" height="22" rx="4" fill="#444441"/><text x="38" y="29" text-anchor="middle" font-family="monospace" font-size="11" font-weight="700" fill="#4A90D9">18.4m</text><text x="38" y="36" text-anchor="middle" font-family="monospace" font-size="7" fill="#9FE1CB">47 min</text><line x1="20" y1="66" x2="60" y2="66" stroke="#888780" stroke-width="2" stroke-linecap="round"/><line x1="22" y1="58" x2="58" y2="74" stroke="#E24B4A" stroke-width="2.5" stroke-linecap="round"/><line x1="22" y1="74" x2="58" y2="58" stroke="#E24B4A" stroke-width="2.5" stroke-linecap="round"/></svg>`,

  /* Update / Support */
  'upd:current': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="14" width="50" height="38" rx="7" fill="#9FE1CB" stroke="#0F6E56" stroke-width="2.5"/><rect x="14" y="20" width="38" height="26" rx="4" fill="#0D0D0D"/><path d="M18 28h30M18 34h22M18 40h26" stroke="#4CAF7D" stroke-width="2" stroke-linecap="round" opacity=".8"/><circle cx="60" cy="56" r="16" fill="#C0DD97" stroke="#3B6D11" stroke-width="2.5"/><path d="M54 56l4 4 8-8" stroke="#3B6D11" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  'upd:regular': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="14" width="50" height="38" rx="7" fill="#E6F1FB" stroke="#185FA5" stroke-width="2.5"/><rect x="14" y="20" width="38" height="26" rx="4" fill="#0D0D0D"/><path d="M18 28h30M18 34h22M18 40h26" stroke="#378ADD" stroke-width="2" stroke-linecap="round" opacity=".7"/><path d="M62 44 Q76 44 76 32 Q76 20 62 20" stroke="#185FA5" stroke-width="3" fill="none" stroke-linecap="round"/><path d="M58 16 L62 20 L58 24" stroke="#185FA5" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="62" cy="56" r="12" fill="#FAC775" stroke="#854F0B" stroke-width="2"/><text x="62" y="60" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="700" fill="#854F0B">!</text></svg>`,
  'upd:old': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="14" width="50" height="38" rx="7" fill="#D3D1C7" stroke="#888780" stroke-width="2.5"/><rect x="14" y="20" width="38" height="26" rx="4" fill="#0D0D0D" opacity=".6"/><path d="M18 28h30M18 34h22M18 40h26" stroke="#888780" stroke-width="2" stroke-linecap="round" opacity=".5"/><circle cx="60" cy="56" r="16" fill="#F7C1C1" stroke="#A32D2D" stroke-width="2.5"/><path d="M54 50l12 12M66 50 54 62" stroke="#A32D2D" stroke-width="3" stroke-linecap="round"/></svg>`,
  'upd:any': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="6" y="18" width="34" height="26" rx="5" fill="#9FE1CB" stroke="#0F6E56" stroke-width="2"/><rect x="10" y="22" width="26" height="18" rx="3" fill="#0D0D0D"/><path d="M14 28h18M14 34h12" stroke="#4CAF7D" stroke-width="1.5" stroke-linecap="round" opacity=".8"/><rect x="44" y="24" width="30" height="22" rx="5" fill="#D3D1C7" stroke="#888780" stroke-width="2"/><rect x="48" y="28" width="22" height="14" rx="3" fill="#0D0D0D" opacity=".6"/><path d="M52 32h14M52 38h8" stroke="#888780" stroke-width="1.5" stroke-linecap="round" opacity=".5"/><text x="40" y="72" text-anchor="middle" font-family="sans-serif" font-size="9" fill="#5F5E5A">egal</text></svg>`,
  'gps:yes': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="40" cy="36" r="20" fill="#B5D4F4" stroke="#185FA5" stroke-width="2.5"/><circle cx="40" cy="36" r="8" fill="#185FA5" opacity=".35"/><circle cx="40" cy="36" r="3.5" fill="#185FA5"/><line x1="40" y1="8" x2="40" y2="16" stroke="#185FA5" stroke-width="2.5" stroke-linecap="round"/><line x1="40" y1="56" x2="40" y2="64" stroke="#185FA5" stroke-width="2.5" stroke-linecap="round"/><line x1="12" y1="36" x2="20" y2="36" stroke="#185FA5" stroke-width="2.5" stroke-linecap="round"/><line x1="60" y1="36" x2="68" y2="36" stroke="#185FA5" stroke-width="2.5" stroke-linecap="round"/><path d="M40 56 L40 70" stroke="#185FA5" stroke-width="2" stroke-linecap="round"/><path d="M34 68 Q40 76 46 68" stroke="#185FA5" stroke-width="2" fill="none" stroke-linecap="round"/></svg>`,
  'gps:no': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="40" cy="40" r="22" fill="#F1EFE8" stroke="#888780" stroke-width="2.5"/><line x1="24" y1="24" x2="56" y2="56" stroke="#E24B4A" stroke-width="3" stroke-linecap="round"/><line x1="56" y1="24" x2="24" y2="56" stroke="#E24B4A" stroke-width="3" stroke-linecap="round"/></svg>`,
  'compass:yes': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="40" cy="40" r="30" fill="#EEF2F7" stroke="#3C4C63" stroke-width="2.5"/><circle cx="40" cy="40" r="22" fill="#F4F6FA" stroke="#3C4C63" stroke-width="1.5"/><polygon points="40,16 44,40 40,38 36,40" fill="#E24B4A"/><polygon points="40,64 44,40 40,42 36,40" fill="#3C4C63"/><circle cx="40" cy="40" r="3" fill="#3C4C63"/><text x="40" y="12" text-anchor="middle" font-family="sans-serif" font-size="8" font-weight="700" fill="#3C4C63">N</text><text x="40" y="73" text-anchor="middle" font-family="sans-serif" font-size="8" font-weight="700" fill="#3C4C63">S</text><text x="10" y="43" text-anchor="middle" font-family="sans-serif" font-size="8" font-weight="700" fill="#3C4C63">W</text><text x="70" y="43" text-anchor="middle" font-family="sans-serif" font-size="8" font-weight="700" fill="#3C4C63">E</text></svg>`,
  'compass:no': `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="40" cy="40" r="30" fill="#F1EFE8" stroke="#888780" stroke-width="2.5" opacity=".5"/><line x1="24" y1="24" x2="56" y2="56" stroke="#E24B4A" stroke-width="3" stroke-linecap="round"/><line x1="56" y1="24" x2="24" y2="56" stroke="#E24B4A" stroke-width="3" stroke-linecap="round"/></svg>`,
};

/* Translation tables */
const T={
  de:{
    announce:'Hier geht es zu den Huellen ->', chip:'Tauchcomputer-Finder', tag:'Entscheidungshilfe',
    introTitle:'Welcher Tauchcomputer passt zu dir?',
    introSub:'Beantworte 12 Fragen - wir zeigen dir deinen idealen Computer und die besten Alternativen.',
    prog:(s,t)=>`Frage ${s} von ${t}`, back:'<- Zurueck', next:'Weiter ->', result:'Ergebnis anzeigen ->',multiHint:'Mehrere Antworten moeglich',
    resTitle:'Dein Tauchcomputer-Ranking', resSub:(n,k)=>`Aus ${n} Modellen - ${k} Kriterien bewertet`,
    runnersLbl:'Weitere Empfehlungen', bestMatch:'Beste Uebereinstimmung', matchLbl:'Uebereinstimmung', approx:'ca.',
    caseAvail:'Huelle verfuegbar', caseLink:n=>`-> Passende Huelle fuer ${n} ansehen`,
    caseBadge:'Huelle', caseViewLnk:'Huelle ansehen ->', affBuy:'* Jetzt kaufen ->', affNote:'Affiliate-Link - ohne Mehrkosten fuer dich.', veryGood:'Sehr passend',
    ctaTitle:'Schuetze deinen neuen Tauchcomputer',
    ctaSub:'FrescH-print fertigt massgenaue TPU-Schutzhuellen fuer die meisten Modelle - auch fuer deinen Favoriten.',
    ctaBtn:'Huellen entdecken ->', restart:'x Neu starten',missingBtn:'Hinweis senden',missingEyebrow:'Hinweis senden',missingTitle:'Fehlt ein wichtiger Computer?',missingSub:'Fehlt ein wichtiger Computer - oder haben wir einen Fehler gemacht? Sag es uns!',missingLblName:'Dein Name',missingLblModel:'Modell / Marke',missingLblMsg:'Nachricht (optional)',missingSubmit:'E-Mail senden',
    sL:{rec:'Recreational',cold:'Kaltwasser',tech:'Technisch',ccr:'CCR',apnea:'Apnoe'},
    dL:{'color-large':'grosses Farbdisplay','color-watch':'kompaktes Farbdisplay','mono':'Monochrom-Display'},
    mm:{
      budget:bl=>`Preis ausserhalb Budget (${bl})`,
      bl:{'<250':'bis 250 EUR','250-500':'bis 500 EUR','500-900':'bis 900 EUR','>900':'ueber 900 EUR'},
      style:s=>`Nicht ideal fuer ${s}`, display:d=>`Display: ${d}`,
      gas:'Gasmanagement nicht ausreichend', airInt:'Keine Luftintegration',
      battUsb:'Nur USB-Akku', battRepl:'Wechselbatterie statt USB',
      updOld:'Kein aktiver Support', compass:'Kein Kompass', gps:'Kein GPS', fmt:'Format passt nicht',
    },
    tagLabels:{
      fmt:'Format passt', budget:'Budget passt', style:'Tauchstil passt', display:'Display passt',
      gas:'Gas passt', airInt:'Luftintegration', battery:'Akku passt',
      connect:'Konnektivitaet', compass:'Kompass', gps:'GPS', logbook:'Logbuch', upd:'Aktualitaet',
    },
    tags:{airInt:'Luftintegration',bestConn:'Beste Konnektivitaet',bt:'Bluetooth',cable:'Kabel/IR',trimix:'Trimix',ccr:'CCR-Modus',usb:'USB-Akku',repl:'Wechselbatterie'},
    qs:[
      {c:'Budget',t:'Was darf dein Tauchcomputer kosten?',h:'Preise sind UVP-Richtwerte. Strassenpreise liegen oft darunter.',k:'budget',
       o:[{a:'budget:<250',l:'Bis 250 EUR',d:'Einstieg, Gelegenheitstaucher',v:'<250'},{a:'budget:250-500',l:'Bis 500 EUR',d:'Gutes Preis-Leistungs-Verhaeltnis',v:'250-500'},{a:'budget:500-900',l:'Bis 900 EUR',d:'Premium, viele Funktionen',v:'500-900'},{a:'budget:>900',l:'Ueber 900 EUR',d:'Profi / Tech / CCR',v:'>900'}]},
      {c:'Tauchstil',t:'Wie tauchst du hauptsaechlich?',h:'Das bestimmt, welche Algorithmen und Gasoptionen relevant sind.',k:'style',
       o:[{a:'style:rec',l:'Recreational',d:'Urlaub, Warmwasser, bis 40 m',v:'rec'},{a:'style:cold',l:'Kaltwasser / Seen',d:'Steinbrueche, Seen, Wracks',v:'cold'},{a:'style:tech',l:'Technisch',d:'Deko, Trimix, Hoehlen',v:'tech'},{a:'style:ccr',l:'CCR / Rebreather',d:'Kreislauftauchgeraet',v:'ccr'},{a:'style:apnea',l:'Apnoe / Freedive',d:'Tauchen ohne Geraet',v:'apnea'}]},
      {c:'Format',t:'Welches Gehaeuseformat bevorzugst du?',h:'Handgelenk-Computer sind groesser, Smartwatch-Format ist schlank und alltagstauglich.',k:'fmt',o:[{a:'fmt:wrist-large',l:'Handgelenk-Computer',d:'Grosses Gehaeuse, breites Display',v:'wrist-large'},{a:'fmt:wrist-watch',l:'Smartwatch-Format',d:'Kompakt, unauffaellig, alltagstauglich',v:'wrist-watch'},{a:'fmt:console',l:'Konsole',d:'Mit Schlauch, am Finimeter',v:'console'},{a:'fmt:any',l:'Egal',d:'Kein Kriterium fuer mich',v:'any'}]},
      {c:'Display',t:'Welches Display ist dir wichtig?',h:'Unter Wasser zaehlt schnelle Lesbarkeit - Farbe hilft, verbraucht aber mehr Akku.',k:'display',
       o:[{a:'display:color-large',l:'Farbig & gross',d:'Maximale Ablesbarkeit',v:'color-large'},{a:'display:color-watch',l:'Farbig, kompakt',d:'Smartwatch-Format',v:'color-watch'},{a:'display:mono',l:'Monochrom',d:'Kontrastreich, langer Akku',v:'mono'},{a:'display:any',l:'Egal',d:'Kein Kriterium',v:'any'}]},
      {c:'Gasmanagement',t:'Welche Gase planst du zu tauchen?',h:'Mehr Gasoptionen = mehr Komplexitaet und Preis.',k:'gas',
       o:[{a:'gas:air',l:'Nur Luft',d:'Standard, Einstieg',v:'air'},{a:'gas:nitrox',l:'Nitrox (EAN)',d:'Bis 40 % O2',v:'nitrox'},{a:'gas:trimix',l:'Trimix / Multi-Gas',d:'Technisch, mehrere Flaschen',v:'trimix'},{a:'gas:ccr-gas',l:'CCR / O2-Steuerung',d:'Rebreather-Modus',v:'ccr-gas'}]},
      {c:'Luftintegration',t:'Soll der Computer deinen Tankdruck anzeigen?',h:'Luftintegration ersetzt den analogen Finimeter. Sender noetig.',k:'airInt',
       o:[{a:'airInt:must',l:'Ja, Pflicht',d:'Ohne LI kaufe ich nicht',v:'must'},{a:'airInt:nice',l:'Waere praktisch',d:'Nett, aber kein Muss',v:'nice'},{a:'airInt:no',l:'Nein',d:'SPG / Konsole reicht',v:'no'}]},
      {c:'Akku',t:'Aufladbarer Akku oder Wechselbatterie?',h:'Wechselbatterien sind ueberall verfuegbar - auch auf dem Tauchboot.',k:'battery',
       o:[{a:'battery:usb',l:'USB aufladbar',d:'Kein Batteriewechsel',v:'usb'},{a:'battery:replaceable',l:'Wechselbatterie',d:'Überall austauschbar',v:'replaceable'},{a:'battery:any',l:'Egal',d:'Kein Kriterium',v:'any'}]},
      {c:'Konnektivitaet',t:'Wie wichtig ist App-Anbindung und Logbuch-Sync?',h:'Bluetooth / Wi-Fi ermoeglichen automatisches Tauchgang-Tracking.',k:'connect',
       o:[{a:'connect:high',l:'Sehr wichtig',d:'App, Cloud, Bluetooth',v:'high'},{a:'connect:mid',l:'Praktisch',d:'Bluetooth waere fein',v:'mid'},{a:'connect:low',l:'Unwichtig',d:'USB / IR-Kabel reicht',v:'low'}]},
      {c:'Kompass',t:'Brauchst du einen integrierten Kompass?',h:'Ein digitaler Kompass erleichtert die Orientierung unter Wasser ohne separates Geraet.',k:'compass',o:[{a:'compass:yes',l:'Ja, wichtig',d:'Digitaler Kompass integriert',v:'yes'},{a:'compass:no',l:'Nein / egal',d:'Kompass nicht benoetigt',v:'no'}]},
      {c:'GPS',t:'Brauchst du GPS?',h:'GPS ermoeglicht die Aufzeichnung von Oberflaechen-Positionen und Tauchplatzen.',k:'gps',o:[{a:'gps:yes',l:'Ja, wichtig',d:'GPS-Empfaenger integriert',v:'yes'},{a:'gps:no',l:'Nein / egal',d:'GPS wird nicht benoetigt',v:'no'}]},
      {c:'Logbuch & Software',t:'Wie intensiv nutzt du das Logbuch?',h:'Viele Taucher schwoeren auf detaillierte Profil-Analyse am PC.',k:'logbook',
       o:[{a:'logbook:power',l:'Power-User',d:'Tiefenprofile, PC-Software, CSV',v:'power'},{a:'logbook:casual',l:'Gelegentlich',d:'Basis-Logbuch am PC',v:'casual'},{a:'logbook:none',l:'Kaum',d:'Display-Daten reichen',v:'none'}]},
      {c:'Aktualitaet',t:'Wie wichtig ist dir aktiver Hersteller-Support?',h:'Aktuelle Firmware-Updates verbessern Algorithmen und beheben Fehler. Aeltere Modelle erhalten oft keinen Support mehr.',k:'upd',o:[{a:'upd:current',l:'Sehr wichtig',d:'Aktuelle Modelle, regelmaessige Updates',v:'current'},{a:'upd:regular',l:'Wichtig',d:'Updates gelegentlich, Support laeuft',v:'regular'},{a:'upd:old',l:'Egal',d:'Aeltere Modelle ok, solange sie funktionieren',v:'old'},{a:'upd:any',l:'Kein Kriterium',d:'Nur die Hardware zaehlt',v:'any'}]},
    ],
  },
  en:{
    announce:'Discover protective cases ->', chip:'Dive Computer Finder', tag:'Decision guide',
    introTitle:'Which dive computer suits you?',
    introSub:'Answer 12 questions - we\'ll show your ideal computer and the best alternatives.',
    prog:(s,t)=>`Question ${s} of ${t}`, back:'<- Back', next:'Next ->', result:'Show results ->',multiHint:'Multiple answers possible',
    resTitle:'Your dive computer ranking', resSub:(n,k)=>`From ${n} models - ${k} criteria evaluated`,
    runnersLbl:'Further recommendations', bestMatch:'Best match', matchLbl:'Match', approx:'approx.',
    caseAvail:'Case available', caseLink:n=>`-> View FrescH-print case for ${n}`,
    caseBadge:'Case', caseViewLnk:'View case ->', affBuy:'* Buy now ->', affNote:'Affiliate link - no extra cost to you.', veryGood:'Great fit',
    ctaTitle:'Protect your new dive computer',
    ctaSub:'FrescH-print makes precision-fit TPU cases for most models - including your favourite.',
    ctaBtn:'Discover cases ->', restart:'x Start over',missingBtn:'Send us a hint',missingEyebrow:'Send hint',missingTitle:'Is an important computer missing?',missingSub:'Is an important computer missing - or did we make a mistake? Let us know!',missingLblName:'Your name',missingLblModel:'Model / Brand',missingLblMsg:'Message (optional)',missingSubmit:'Send email',
    sL:{rec:'Recreational',cold:'Cold water',tech:'Technical',ccr:'CCR',apnea:'Freediving'},
    dL:{'color-large':'large colour display','color-watch':'compact colour display','mono':'monochrome display'},
    mm:{
      budget:bl=>`Price outside budget (${bl})`,
      bl:{'<250':'up to EUR250','250-500':'up to EUR500','500-900':'up to EUR900','>900':'over EUR900'},
      style:s=>`Not ideal for ${s}`, display:d=>`Display: ${d}`,
      gas:'Gas management insufficient', airInt:'No air integration',
      battUsb:'USB only (no battery swap)', battRepl:'Replaceable battery instead of USB',
      updOld:'No active support', compass:'No compass', gps:'No GPS', fmt:'Format does not match',
    },
    tagLabels:{
      fmt:'Format fits', budget:'Budget fits', style:'Dive style fits', display:'Display fits',
      gas:'Gas fits', airInt:'Air integration', battery:'Battery fits',
      connect:'Connectivity', compass:'Compass', gps:'GPS', logbook:'Logbook', upd:'Support',
    },
    tags:{airInt:'Air integration',bestConn:'Best connectivity',bt:'Bluetooth',cable:'Cable/IR',trimix:'Trimix',ccr:'CCR mode',usb:'USB battery',repl:'Replaceable battery'},
    qs:[
      {c:'Budget',t:'How much would you like to spend?',h:'Prices are RRP estimates. Street prices are often lower.',k:'budget',
       o:[{a:'budget:<250',l:'Up to EUR250',d:'Entry level, casual diver',v:'<250'},{a:'budget:250-500',l:'Up to EUR500',d:'Good value for money',v:'250-500'},{a:'budget:500-900',l:'Up to EUR900',d:'Premium, lots of features',v:'500-900'},{a:'budget:>900',l:'Over EUR900',d:'Pro / Tech / CCR',v:'>900'}]},
      {c:'Diving style',t:'How do you mainly dive?',h:'This determines which algorithms and gas options are relevant.',k:'style',
       o:[{a:'style:rec',l:'Recreational',d:'Holiday, warm water, up to 40 m',v:'rec'},{a:'style:cold',l:'Cold water / lakes',d:'Quarries, lakes, wrecks',v:'cold'},{a:'style:tech',l:'Technical',d:'Deco, trimix, caves',v:'tech'},{a:'style:ccr',l:'CCR / Rebreather',d:'Closed-circuit rebreather',v:'ccr'},{a:'style:apnea',l:'Freediving',d:'Breath-hold diving',v:'apnea'}]},
      {c:'Form factor',t:'Which housing format do you prefer?',h:'Wrist computers are chunkier. Smartwatch format is subtle and everyday-wearable.',k:'fmt',o:[{a:'fmt:wrist-large',l:'Wrist computer',d:'Large housing, wide display',v:'wrist-large'},{a:'fmt:wrist-watch',l:'Smartwatch format',d:'Compact, subtle, daily wearable',v:'wrist-watch'},{a:'fmt:console',l:'Console',d:'Hose-mounted, with SPG',v:'console'},{a:'fmt:any',l:'No preference',d:'Not a deciding factor',v:'any'}]},
      {c:'Display',t:'What kind of display matters to you?',h:'Readability underwater is key - colour helps but drains the battery.',k:'display',
       o:[{a:'display:color-large',l:'Colour & large',d:'Maximum readability',v:'color-large'},{a:'display:color-watch',l:'Colour, compact',d:'Smartwatch size on the wrist',v:'color-watch'},{a:'display:mono',l:'Monochrome',d:'High contrast, long battery',v:'mono'},{a:'display:any',l:'No preference',d:'Not a deciding factor',v:'any'}]},
      {c:'Gas management',t:'Which gases do you plan to dive?',h:'More gas options = more complexity and cost.',k:'gas',
       o:[{a:'gas:air',l:'Air only',d:'Standard, entry level',v:'air'},{a:'gas:nitrox',l:'Nitrox (EAN)',d:'Up to 40 % O2',v:'nitrox'},{a:'gas:trimix',l:'Trimix / multi-gas',d:'Technical, multiple cylinders',v:'trimix'},{a:'gas:ccr-gas',l:'CCR / O2 control',d:'Rebreather mode needed',v:'ccr-gas'}]},
      {c:'Air integration',t:'Should the computer display your tank pressure?',h:'Air integration replaces the analogue SPG. A transmitter is required.',k:'airInt',
       o:[{a:'airInt:must',l:'Yes, essential',d:"Won't buy without it",v:'must'},{a:'airInt:nice',l:'Would be nice',d:'Handy but not a must',v:'nice'},{a:'airInt:no',l:'No',d:'Console / SPG is fine',v:'no'}]},
      {c:'Battery',t:'Rechargeable battery or swappable cells?',h:'Replaceable batteries are available everywhere - even on the dive boat.',k:'battery',
       o:[{a:'battery:usb',l:'USB rechargeable',d:'No battery swap needed',v:'usb'},{a:'battery:replaceable',l:'Replaceable battery',d:'Swappable anywhere',v:'replaceable'},{a:'battery:any',l:'No preference',d:'Not a deciding factor',v:'any'}]},
      {c:'Connectivity',t:'How important is app support and log sync?',h:'Bluetooth / Wi-Fi enable automatic dive tracking.',k:'connect',
       o:[{a:'connect:high',l:'Very important',d:'App, cloud logbook, Bluetooth',v:'high'},{a:'connect:mid',l:'Handy',d:'Bluetooth would be nice',v:'mid'},{a:'connect:low',l:'Not important',d:'USB / IR cable is fine',v:'low'}]},
      {c:'Compass',t:'Do you need an integrated compass?',h:'A digital compass makes underwater navigation easier without a separate device.',k:'compass',o:[{a:'compass:yes',l:'Yes, important',d:'Integrated digital compass',v:'yes'},{a:'compass:no',l:'No / does not matter',d:'Compass not needed',v:'no'}]},
      {c:'GPS',t:'Do you need GPS?',h:'GPS allows recording surface positions and dive site locations.',k:'gps',o:[{a:'gps:yes',l:'Yes, important',d:'Integrated GPS receiver',v:'yes'},{a:'gps:no',l:'No / does not matter',d:'GPS not needed',v:'no'}]},
      {c:'Logbook & software',t:'How intensively do you use the logbook?',h:'Many divers swear by detailed dive profile analysis on their PC.',k:'logbook',
       o:[{a:'logbook:power',l:'Power user',d:'Depth profiles, PC software, CSV',v:'power'},{a:'logbook:casual',l:'Occasionally',d:'Basic logbook on the computer',v:'casual'},{a:'logbook:none',l:'Barely',d:'Display data is enough',v:'none'}]},
      {c:'Software & support',t:'How important is active manufacturer support to you?',h:'Firmware updates improve algorithms and fix bugs. Older models often no longer receive support.',k:'upd',o:[{a:'upd:current',l:'Very important',d:'Current models, regular updates',v:'current'},{a:'upd:regular',l:'Important',d:'Occasional updates, support running',v:'regular'},{a:'upd:old',l:'Not important',d:'Older models fine as long as they work',v:'old'},{a:'upd:any',l:'No criterion',d:'Only the hardware matters',v:'any'}]},
    ],
  },
  es:{
    announce:'Descubrir las fundas ->', chip:'Buscador de ordenadores', tag:'Guia de decision',
    introTitle:'Que ordenador de buceo es el tuyo?',
    introSub:'Responde 12 preguntas y te mostraremos tu ordenador ideal y las mejores alternativas.',
    prog:(s,t)=>`Pregunta ${s} de ${t}`, back:'<- Atras', next:'Siguiente ->', result:'Ver resultados ->',multiHint:'Varias respuestas posibles',
    resTitle:'Tu ranking de ordenadores de buceo', resSub:(n,k)=>`De ${n} modelos - ${k} criterios evaluados`,
    runnersLbl:'Mas recomendaciones', bestMatch:'Mejor coincidencia', matchLbl:'Coincidencia', approx:'aprox.',
    caseAvail:'Funda disponible', caseLink:n=>`-> Ver funda FrescH-print para ${n}`,
    caseBadge:'Funda', caseViewLnk:'Ver funda ->', affBuy:'* Comprar ahora ->', affNote:'Enlace de afiliado - sin coste adicional.', veryGood:'Muy adecuado',
    ctaTitle:'Protege tu nuevo ordenador de buceo',
    ctaSub:'FrescH-print fabrica fundas TPU a medida para la mayoria de modelos - incluido tu favorito.',
    ctaBtn:'Descubrir fundas ->', restart:'x Empezar de nuevo',missingBtn:'Envianos un aviso',missingEyebrow:'Enviar aviso',missingTitle:'Falta un ordenador importante?',missingSub:'Falta un ordenador importante o cometimos un error? Dinos!',missingLblName:'Tu nombre',missingLblModel:'Modelo / Marca',missingLblMsg:'Mensaje (opcional)',missingSubmit:'Enviar correo',
    sL:{rec:'Recreativo',cold:'Agua fria',tech:'Tecnico',ccr:'CCR',apnea:'Apnea'},
    dL:{'color-large':'pantalla color grande','color-watch':'pantalla color compacta','mono':'pantalla monocromatica'},
    mm:{budget:bl=>`Precio fuera de presupuesto (${bl})`,bl:{'<250':'hasta 250 EUR','250-500':'hasta 500 EUR','500-900':'hasta 900 EUR','>900':'mas de 900 EUR'},style:s=>`No ideal para ${s}`,display:d=>`Pantalla: ${d}`,gas:'Gestion de gas insuficiente',airInt:'Sin integracion de aire',battUsb:'Solo recargable USB',battRepl:'Pila reemplazable en lugar USB',updOld:'Sin soporte activo',compass:'Sin brujula',gps:'Sin GPS',fmt:'Formato no coincide'},
    tagLabels:{fmt:'Formato',budget:'Presupuesto OK',style:'Estilo OK',display:'Pantalla OK',gas:'Gas OK',airInt:'Integr. aire',battery:'Bateria OK',connect:'Conectividad',compass:'Brujula',gps:'GPS',logbook:'Diario',upd:'Actualidad'},
    tags:{airInt:'Integracion aire',bestConn:'Mejor conectividad',bt:'Bluetooth',cable:'Cable/IR',trimix:'Trimix',ccr:'Modo CCR',usb:'Bateria USB',repl:'Pila reemplazable'},
    qs:[
      {c:'Presupuesto',t:'Cuanto quieres gastar?',h:'Los precios son PVP orientativos. Los precios en tienda suelen ser mas bajos.',k:'budget',o:[{a:'budget:<250',l:'Hasta 250 EUR',d:'Nivel basico, ocasional',v:'<250'},{a:'budget:250-500',l:'Hasta 500 EUR',d:'Buena relacion calidad-precio',v:'250-500'},{a:'budget:500-900',l:'Hasta 900 EUR',d:'Premium, muchas funciones',v:'500-900'},{a:'budget:>900',l:'Mas de 900 EUR',d:'Profesional / Tecnico / CCR',v:'>900'}]},
      {c:'Estilo de buceo',t:'Como buceas principalmente?',h:'Esto determina que algoritmos y opciones de gas son relevantes.',k:'style',o:[{a:'style:rec',l:'Recreativo',d:'Vacaciones, aguas calidas, 40 m',v:'rec'},{a:'style:cold',l:'Agua fria / lagos',d:'Canteras, lagos, pecios',v:'cold'},{a:'style:tech',l:'Tecnico',d:'Deco, trimix, cuevas',v:'tech'},{a:'style:ccr',l:'CCR / Rebreather',d:'Circuito cerrado',v:'ccr'},{a:'style:apnea',l:'Apnea',d:'Buceo sin equipo',v:'apnea'}]},
      {c:'Formato',t:'Que formato de carcasa prefieres?',h:'Los ordenadores de muneca son mas grandes. El formato reloj es discreto y para uso diario.',k:'fmt',o:[{a:'fmt:wrist-large',l:'Ordenador de muneca',d:'Carcasa grande, pantalla amplia',v:'wrist-large'},{a:'fmt:wrist-watch',l:'Formato reloj',d:'Compacto, discreto, para uso diario',v:'wrist-watch'},{a:'fmt:console',l:'Consola',d:'Con manguera, junto al manometro',v:'console'},{a:'fmt:any',l:'Sin preferencia',d:'No es un criterio para mi',v:'any'}]},
      {c:'Pantalla',t:'Que tipo de pantalla te importa?',h:'Bajo el agua la legibilidad es clave - el color ayuda pero consume bateria.',k:'display',o:[{a:'display:color-large',l:'Color y grande',d:'Maxima legibilidad',v:'color-large'},{a:'display:color-watch',l:'Color, compacta',d:'Formato reloj inteligente',v:'color-watch'},{a:'display:mono',l:'Monocromatica',d:'Alto contraste, larga bateria',v:'mono'},{a:'display:any',l:'Sin preferencia',d:'No es decisivo para mi',v:'any'}]},
      {c:'Gestion de gas',t:'Que gases planeas utilizar?',h:'Mas opciones de gas = mas complejidad y precio.',k:'gas',o:[{a:'gas:air',l:'Solo aire',d:'Estandar, basico',v:'air'},{a:'gas:nitrox',l:'Nitrox (EAN)',d:'Hasta 40 % O2',v:'nitrox'},{a:'gas:trimix',l:'Trimix / multigas',d:'Tecnico, varias botellas',v:'trimix'},{a:'gas:ccr-gas',l:'CCR / control O2',d:'Modo rebreather',v:'ccr-gas'}]},
      {c:'Integracion de aire',t:'Debe el ordenador mostrar la presion de tu botella?',h:'Reemplaza el manometro analogico. Se necesita transmisor.',k:'airInt',o:[{a:'airInt:must',l:'Si, imprescindible',d:'No compro sin ella',v:'must'},{a:'airInt:nice',l:'Seria util',d:'Comodo pero no esencial',v:'nice'},{a:'airInt:no',l:'No',d:'Un manometro me basta',v:'no'}]},
      {c:'Bateria',t:'Bateria recargable o pilas intercambiables?',h:'Las pilas intercambiables estan disponibles en cualquier lugar.',k:'battery',o:[{a:'battery:usb',l:'Recargable USB',d:'Sin cambio de pila',v:'usb'},{a:'battery:replaceable',l:'Pilas reemplazables',d:'Intercambiables en cualquier lugar',v:'replaceable'},{a:'battery:any',l:'Sin preferencia',d:'No es decisivo',v:'any'}]},
      {c:'Conectividad',t:'Que importancia tiene la app y la sincronizacion?',h:'Bluetooth / Wi-Fi permiten el seguimiento automatico.',k:'connect',o:[{a:'connect:high',l:'Muy importante',d:'App, nube, Bluetooth',v:'high'},{a:'connect:mid',l:'Practico',d:'Bluetooth estaria bien',v:'mid'},{a:'connect:low',l:'No importante',d:'Cable USB / IR me basta',v:'low'}]},
      {c:'Brujula',t:'Necesitas una brujula integrada?',h:'Una brujula digital facilita la navegacion bajo el agua sin dispositivo separado.',k:'compass',o:[{a:'compass:yes',l:'Si, importante',d:'Brujula digital integrada',v:'yes'},{a:'compass:no',l:'No / da igual',d:'Brujula no necesaria',v:'no'}]},
      {c:'GPS',t:'Necesitas GPS?',h:'El GPS permite registrar posiciones en superficie y ubicaciones de sitios de buceo.',k:'gps',o:[{a:'gps:yes',l:'Si, importante',d:'Receptor GPS integrado',v:'yes'},{a:'gps:no',l:'No / da igual',d:'GPS no necesario',v:'no'}]},
      {c:'Libro de inmersiones',t:'Con que intensidad usas el diario de inmersiones?',h:'Muchos buceadores juran por el analisis de perfiles en el PC.',k:'logbook',o:[{a:'logbook:power',l:'Usuario avanzado',d:'Perfiles, software PC',v:'power'},{a:'logbook:casual',l:'Ocasionalmente',d:'Diario basico en PC',v:'casual'},{a:'logbook:none',l:'Apenas',d:'Los datos del display bastan',v:'none'}]},
      {c:'Actualizaciones y soporte',t:'Que importancia tiene el soporte activo del fabricante?',h:'Las actualizaciones de firmware mejoran los algoritmos y corrigen errores. Los modelos mas antiguos a menudo ya no reciben soporte.',k:'upd',o:[{a:'upd:current',l:'Muy importante',d:'Modelos actuales, actualizaciones frecuentes',v:'current'},{a:'upd:regular',l:'Importante',d:'Actualizaciones ocasionales, soporte activo',v:'regular'},{a:'upd:old',l:'No importa',d:'Modelos antiguos estan bien si funcionan',v:'old'},{a:'upd:any',l:'Sin criterio',d:'Solo importa el hardware',v:'any'}]},
    ],
  },
  fr:{
    announce:'Decouvrir les coques de protection ->', chip:'Comparateur de plongee', tag:'Guide de decision',
    introTitle:'Quel ordinateur de plongee vous correspond ?',
    introSub:'Repondez 12 questions - nous vous montrerons votre ordinateur ideal et les meilleures alternatives.',
    prog:(s,t)=>`Question ${s} sur ${t}`, back:'<- Retour', next:'Suivant ->', result:'Voir les resultats ->',multiHint:'Plusieurs reponses possibles',
    resTitle:"Votre classement d'ordinateurs de plongee", resSub:(n,k)=>`Sur ${n} modeles - ${k} criteres evalues`,
    runnersLbl:'Autres recommandations', bestMatch:'Meilleure correspondance', matchLbl:'Correspondance', approx:'env.',
    caseAvail:'Coque disponible', caseLink:n=>`-> Voir la coque FrescH-print pour ${n}`,
    caseBadge:'Coque', caseViewLnk:'Voir la coque ->', affBuy:'* Acheter ->', affNote:'Lien affilie - sans frais supplementaires.', veryGood:'Tres adapte',
    ctaTitle:'Protegez votre nouvel ordinateur de plongee',
    ctaSub:'FrescH-print fabrique des coques TPU sur mesure pour la plupart des modeles - y compris votre favori.',
    ctaBtn:'Decouvrir les coques ->', restart:'x Recommencer',missingBtn:'Nous envoyer un conseil',missingEyebrow:'Envoyer conseil',missingTitle:'Un ordinateur important manque ?',missingSub:'Un ordinateur important manque - ou avons-nous fait une erreur ? Dites-le nous !',missingLblName:'Votre nom',missingLblModel:'Modele / Marque',missingLblMsg:'Message (facultatif)',missingSubmit:'Envoyer e-mail',
    sL:{rec:'Recreatif',cold:'Eau froide',tech:'Technique',ccr:'CCR',apnea:'Apnee'},
    dL:{'color-large':'grand ecran couleur','color-watch':'ecran couleur compact','mono':'ecran monochrome'},
    mm:{budget:bl=>`Prix hors budget (${bl})`,bl:{'<250':'jusqu\'a 250 EUR','250-500':'jusqu\'a 500 EUR','500-900':'jusqu\'a 900 EUR','>900':'plus de 900 EUR'},style:s=>`Pas ideal pour ${s}`,display:d=>`Ecran : ${d}`,gas:'Gestion des gaz insuffisante',airInt:"Pas d'integration air",battUsb:'Rechargeable USB uniquement',battRepl:'Pile remplaçable au lieu USB',updOld:'Plus de support actif',compass:'Pas de boussole',gps:'Pas de GPS',fmt:'Mauvais format'},
    tagLabels:{fmt:'Format',budget:'Budget OK',style:'Style OK',display:'Ecran OK',gas:'Gaz OK',airInt:'Integr. air',battery:'Batterie OK',connect:'Connectivite',compass:'Boussole',gps:'GPS',logbook:'Carnet',upd:'Maj'},
    tags:{airInt:'Integration air',bestConn:'Meilleure connectivite',bt:'Bluetooth',cable:'Cable/IR',trimix:'Trimix',ccr:'Mode CCR',usb:'Batterie USB',repl:'Pile remplaçable'},
    qs:[
      {c:'Budget',t:'Quel est votre budget pour un ordinateur de plongee ?',h:'Les prix sont des PVC indicatifs. Les prix en magasin sont souvent inferieurs.',k:'budget',o:[{a:'budget:<250',l:"Jusqu'a 250 EUR",d:'Entree de gamme, occasionnel',v:'<250'},{a:'budget:250-500',l:"Jusqu'a 500 EUR",d:'Bon rapport qualite-prix',v:'250-500'},{a:'budget:500-900',l:"Jusqu'a 900 EUR",d:'Premium, nombreuses fonctions',v:'500-900'},{a:'budget:>900',l:'Plus de 900 EUR',d:'Pro / Technique / CCR',v:'>900'}]},
      {c:'Style de plongee',t:'Comment plongez-vous principalement ?',h:'Cela determine les algorithmes et options de gaz pertinents.',k:'style',o:[{a:'style:rec',l:'Recreatif',d:'Vacances, eaux chaudes, 40 m max',v:'rec'},{a:'style:cold',l:'Eau froide / lacs',d:'Carrieres, lacs, epaves',v:'cold'},{a:'style:tech',l:'Technique',d:'Deco, trimix, grottes',v:'tech'},{a:'style:ccr',l:'CCR / Recycleur',d:'Circuit ferme',v:'ccr'},{a:'style:apnea',l:'Apnee',d:"Plongee en apnee",v:'apnea'}]},
      {c:'Format',t:'Quel format de boitier preferez-vous ?',h:"Les ordinateurs de poignet sont plus grands. Le format montre est discret et se porte au quotidien.",k:'fmt',o:[{a:'fmt:wrist-large',l:'Ordinateur de poignet',d:'Grand boitier, large ecran',v:'wrist-large'},{a:'fmt:wrist-watch',l:'Format montre',d:'Compact, discret, pour usage quotidien',v:'wrist-watch'},{a:'fmt:console',l:'Console',d:'Monte sur flexible, avec manometre',v:'console'},{a:'fmt:any',l:'Peu importe',d:'Pas un critere pour moi',v:'any'}]},
      {c:'Ecran',t:"Quel type d'ecran est important pour vous ?",h:"La lisibilite sous l'eau est essentielle - la couleur aide mais consomme la batterie.",k:'display',o:[{a:'display:color-large',l:'Couleur & grand',d:'Lisibilite maximale',v:'color-large'},{a:'display:color-watch',l:'Couleur, compact',d:'Format montre connectee',v:'color-watch'},{a:'display:mono',l:'Monochrome',d:'Contraste eleve, longue autonomie',v:'mono'},{a:'display:any',l:'Peu importe',d:'Pas un critere pour moi',v:'any'}]},
      {c:'Gestion des gaz',t:'Quels gaz prevoyez-vous de plonger ?',h:"Plus d'options de gaz = plus de complexite et de coût.",k:'gas',o:[{a:'gas:air',l:'Air seulement',d:'Standard, niveau debutant',v:'air'},{a:'gas:nitrox',l:'Nitrox (EAN)',d:"Jusqu'a 40 % O2",v:'nitrox'},{a:'gas:trimix',l:'Trimix / multigaz',d:'Technique, plusieurs bouteilles',v:'trimix'},{a:'gas:ccr-gas',l:'CCR / contrôle O2',d:'Mode recycleur necessaire',v:'ccr-gas'}]},
      {c:'Integration air',t:'L\'ordinateur doit-il afficher la pression de votre bouteille ?',h:"L\'integration air remplace le manometre analogique. Un emetteur est necessaire.",k:'airInt',o:[{a:'airInt:must',l:'Oui, indispensable',d:"Je n\'achete pas sans",v:'must'},{a:'airInt:nice',l:'Ce serait pratique',d:'Utile mais pas obligatoire',v:'nice'},{a:'airInt:no',l:'Non',d:'Un manometre me suffit',v:'no'}]},
      {c:'Batterie',t:'Batterie rechargeable ou piles remplaçables ?',h:'Les piles remplaçables sont disponibles partout - meme sur le bateau.',k:'battery',o:[{a:'battery:usb',l:'Rechargeable USB',d:'Pas de remplacement de pile',v:'usb'},{a:'battery:replaceable',l:'Piles remplaçables',d:'Remplaçables partout',v:'replaceable'},{a:'battery:any',l:'Peu importe',d:'Pas un critere',v:'any'}]},
      {c:'Connectivite',t:'Quelle importance accordez-vous a l\'app et a la synchronisation ?',h:'Bluetooth / Wi-Fi permettent le suivi automatique des plongees.',k:'connect',o:[{a:'connect:high',l:'Tres important',d:'App, cloud, Bluetooth',v:'high'},{a:'connect:mid',l:'Pratique',d:'Bluetooth serait bien',v:'mid'},{a:'connect:low',l:'Sans importance',d:'Cable USB / IR suffit',v:'low'}]},
      {c:'Boussole',t:'Avez-vous besoin d\'une boussole integree ?',h:'Une boussole digitale facilite la navigation sous-marine sans appareil separe.',k:'compass',o:[{a:'compass:yes',l:'Oui, important',d:'Boussole numerique integree',v:'yes'},{a:'compass:no',l:'Non / peu importe',d:'Boussole pas necessaire',v:'no'}]},
      {c:'GPS',t:'Avez-vous besoin du GPS ?',h:'Le GPS permet d\'enregistrer les positions en surface et les sites de plongee.',k:'gps',o:[{a:'gps:yes',l:'Oui, important',d:'Recepteur GPS integre',v:'yes'},{a:'gps:no',l:'Non / peu importe',d:'GPS pas necessaire',v:'no'}]},
      {c:'Carnet de plongee',t:'A quelle frequence utilisez-vous le carnet de plongee ?',h:"Beaucoup de plongeurs apprecient l'analyse detaillee des profils sur PC.",k:'logbook',o:[{a:'logbook:power',l:'Utilisateur avance',d:'Profils, logiciel PC, CSV',v:'power'},{a:'logbook:casual',l:'Occasionnellement',d:'Carnet de base sur PC',v:'casual'},{a:'logbook:none',l:'Rarement',d:"Les donnees de l'ecran suffisent",v:'none'}]},
      {c:'Mises a jour & support',t:'Quelle importance accordez-vous au support actif du fabricant ?',h:'Les mises a jour du firmware ameliorent les algorithmes et corrigent les bugs. Les modeles plus anciens ne reçoivent souvent plus de support.',k:'upd',o:[{a:'upd:current',l:'Tres important',d:'Modeles recents, mises a jour regulieres',v:'current'},{a:'upd:regular',l:'Important',d:'Mises a jour occasionnelles, support actif',v:'regular'},{a:'upd:old',l:'Peu importe',d:'Modeles anciens OK s\'ils fonctionnent',v:'old'},{a:'upd:any',l:'Pas un critere',d:'Seul le materielriel compte',v:'any'}]},
    ],
  },
  it:{
    announce:'Scopri le custodie protettive ->', chip:'Trova il tuo computer', tag:'Guida alla scelta',
    introTitle:'Quale computer da immersione fa per te?',
    introSub:'Rispondi a 12 domande - ti mostreremo il computer ideale e le migliori alternative.',
    prog:(s,t)=>`Domanda ${s} di ${t}`, back:'<- Indietro', next:'Avanti ->', result:'Mostra risultati ->',multiHint:'Piu risposte possibili',
    resTitle:'La tua classifica di computer da immersione', resSub:(s,k)=>`Da ${s} modelli - ${k} criteri valutati`,
    runnersLbl:'Ulteriori raccomandazioni', bestMatch:'Migliore corrispondenza', matchLbl:'Corrispondenza', approx:'ca.',
    caseAvail:'Custodia disponibile', caseLink:n=>`-> Vedi la custodia FrescH-print per ${n}`,
    caseBadge:'Custodia', caseViewLnk:'Vedi custodia ->', affBuy:'* Acquista ora ->', affNote:'Link affiliato - senza costi aggiuntivi.', veryGood:'Molto adatto',
    ctaTitle:'Proteggi il tuo nuovo computer da immersione',
    ctaSub:'FrescH-print produce custodie TPU su misura per la maggior parte dei modelli - incluso il tuo preferito.',
    ctaBtn:'Scopri le custodie ->', restart:'x Ricomincia',missingBtn:'Inviaci un suggerimento',missingEyebrow:'Invia suggerimento',missingTitle:'Manca un computer importante?',missingSub:'Manca un computer importante - o abbiamo commesso un errore? Dimmelo!',missingLblName:'Il tuo nome',missingLblModel:'Modello / Marca',missingLblMsg:'Messaggio (opzionale)',missingSubmit:'Invia email',
    sL:{rec:'Ricreativo',cold:'Acque fredde',tech:'Tecnico',ccr:'CCR',apnea:'Apnea'},
    dL:{'color-large':'display a colori grande','color-watch':'display a colori compatto','mono':'display monocromatico'},
    mm:{budget:bl=>`Prezzo fuori budget (${bl})`,bl:{'<250':'fino a 250 EUR','250-500':'fino a 500 EUR','500-900':'fino a 900 EUR','>900':'oltre 900 EUR'},style:s=>`Non ideale per ${s}`,display:d=>`Display: ${d}`,gas:'Gestione gas insufficiente',airInt:'Nessuna integrazione aria',battUsb:'Solo ricaricabile USB',battRepl:'Pila sostituibile invece USB',updOld:'Nessun supporto attivo',compass:'Nessuna bussola',gps:'Nessun GPS',fmt:'Formato sbagliato'},
    tagLabels:{fmt:'Form factor',budget:'Budget OK',style:'Stile OK',display:'Display OK',gas:'Gas OK',airInt:'Integr. aria',battery:'Batteria OK',connect:'Connettivita',compass:'Bussola',gps:'GPS',logbook:'Diario',upd:'Aggiornato'},
    tags:{airInt:'Integrazione aria',bestConn:'Migliore connettivita',bt:'Bluetooth',cable:'Cavo/IR',trimix:'Trimix',ccr:'Modalita CCR',usb:'Batteria USB',repl:'Pila sostituibile'},
    qs:[
      {c:'Budget',t:'Quanto vuoi spendere per un computer da immersione?',h:'I prezzi sono prezzi consigliati. I prezzi in negozio sono spesso inferiori.',k:'budget',o:[{a:'budget:<250',l:'Fino a 250 EUR',d:'Entry level, subacqueo occasionale',v:'<250'},{a:'budget:250-500',l:'Fino a 500 EUR',d:'Buon rapporto qualita-prezzo',v:'250-500'},{a:'budget:500-900',l:'Fino a 900 EUR',d:'Premium, molte funzioni',v:'500-900'},{a:'budget:>900',l:'Oltre 900 EUR',d:'Professionale / Tecnico / CCR',v:'>900'}]},
      {c:'Stile di immersione',t:'Come ti immergi principalmente?',h:'Questo determina quali algoritmi e opzioni gas sono rilevanti.',k:'style',o:[{a:'style:rec',l:'Ricreativo',d:'Vacanze, acque calde, fino a 40 m',v:'rec'},{a:'style:cold',l:'Acque fredde / laghi',d:'Cave, laghi, relitti',v:'cold'},{a:'style:tech',l:'Tecnico',d:'Deco, trimix, grotte',v:'tech'},{a:'style:ccr',l:'CCR / Rebreather',d:'Circuito chiuso',v:'ccr'},{a:'style:apnea',l:'Apnea',d:'Immersione in apnea',v:'apnea'}]},
      {c:'Formato',t:'Quale formato di alloggiamento preferisci?',h:'I computer da polso sono piu grandi. Il formato smartwatch e discreto e da indossare ogni giorno.',k:'fmt',o:[{a:'fmt:wrist-large',l:'Computer da polso',d:'Alloggiamento grande, display ampio',v:'wrist-large'},{a:'fmt:wrist-watch',l:'Formato smartwatch',d:'Compatto, discreto, da indossare ogni giorno',v:'wrist-watch'},{a:'fmt:console',l:'Console',d:'Montata su tubo, con manometro',v:'console'},{a:'fmt:any',l:'Non importa',d:'Non e un criterio per me',v:'any'}]},
      {c:'Display',t:"Che tipo di display ti interessa?",h:"Sott'acqua la leggibilita e fondamentale - il colore aiuta ma consuma la batteria.",k:'display',o:[{a:'display:color-large',l:'Colore e grande',d:'Massima leggibilita',v:'color-large'},{a:'display:color-watch',l:'Colore, compatto',d:'Formato smartwatch al polso',v:'color-watch'},{a:'display:mono',l:'Monocromatico',d:'Alto contrasto, lunga autonomia',v:'mono'},{a:'display:any',l:'Non importa',d:'Non e un criterio per me',v:'any'}]},
      {c:'Gestione gas',t:'Quali gas pensi di utilizzare?',h:'Piu opzioni gas = piu complessita e costo.',k:'gas',o:[{a:'gas:air',l:'Solo aria',d:'Standard, base',v:'air'},{a:'gas:nitrox',l:'Nitrox (EAN)',d:'Fino al 40 % O2',v:'nitrox'},{a:'gas:trimix',l:'Trimix / multigas',d:'Tecnico, piu bombole',v:'trimix'},{a:'gas:ccr-gas',l:'CCR / controllo O2',d:'Modalita rebreather',v:'ccr-gas'}]},
      {c:'Integrazione aria',t:'Il computer deve visualizzare la pressione della tua bombola?',h:"L'integrazione aria sostituisce il manometro analogico. E necessario un trasmettitore.",k:'airInt',o:[{a:'airInt:must',l:'Si, indispensabile',d:'Non acquisto senza',v:'must'},{a:'airInt:nice',l:'Sarebbe utile',d:'Comodo ma non essenziale',v:'nice'},{a:'airInt:no',l:'No',d:'Un manometro mi basta',v:'no'}]},
      {c:'Batteria',t:'Batteria ricaricabile o pile sostituibili?',h:'Le pile sostituibili sono disponibili ovunque - anche in barca.',k:'battery',o:[{a:'battery:usb',l:'Ricaricabile USB',d:'Nessuna sostituzione pile',v:'usb'},{a:'battery:replaceable',l:'Pile sostituibili',d:'Sostituibili ovunque',v:'replaceable'},{a:'battery:any',l:'Non importa',d:'Non e un criterio',v:'any'}]},
      {c:'Connettivita',t:"Quanto e importante la connettivita con l'app?",h:'Bluetooth / Wi-Fi consentono il tracciamento automatico delle immersioni.',k:'connect',o:[{a:'connect:high',l:'Molto importante',d:'App, cloud, Bluetooth',v:'high'},{a:'connect:mid',l:'Pratico',d:'Bluetooth sarebbe comodo',v:'mid'},{a:'connect:low',l:'Non importante',d:'Cavo USB / IR e sufficiente',v:'low'}]},
      {c:'Bussola',t:'Hai bisogno di una bussola integrata?',h:'Una bussola digitale facilita la navigazione subacquea senza dispositivo separato.',k:'compass',o:[{a:'compass:yes',l:'Si, importante',d:'Bussola digitale integrata',v:'yes'},{a:'compass:no',l:'No / non importa',d:'Bussola non necessaria',v:'no'}]},
      {c:'GPS',t:'Hai bisogno del GPS?',h:'Il GPS consente di registrare le posizioni in superficie e i siti di immersione.',k:'gps',o:[{a:'gps:yes',l:'Si, importante',d:'Ricevitore GPS integrato',v:'yes'},{a:'gps:no',l:'No / non importa',d:'GPS non necessario',v:'no'}]},
      {c:'Diario delle immersioni',t:'Con quale intensita usi il diario delle immersioni?',h:'Molti subacquei apprezzano l\'analisi dettagliata dei profili sul PC.',k:'logbook',o:[{a:'logbook:power',l:'Utente avanzato',d:'Profili, software PC, CSV',v:'power'},{a:'logbook:casual',l:'Occasionalmente',d:'Diario base sul PC',v:'casual'},{a:'logbook:none',l:'Raramente',d:'I dati del display bastano',v:'none'}]},
      {c:'Aggiornamenti & supporto',t:'Quanto e importante per te il supporto attivo del produttore?',h:'Gli aggiornamenti del firmware migliorano gli algoritmi e correggono i bug. I modelli piu vecchi spesso non ricevono piu supporto.',k:'upd',o:[{a:'upd:current',l:'Molto importante',d:'Modelli recenti, aggiornamenti regolari',v:'current'},{a:'upd:regular',l:'Importante',d:'Aggiornamenti occasionali, supporto attivo',v:'regular'},{a:'upd:old',l:'Non importa',d:'Modelli vecchi OK se funzionano',v:'old'},{a:'upd:any',l:'Nessun criterio',d:'Conta solo l\'hardware',v:'any'}]},
    ],
  },
};

/* ?? Database ?? */
/* ?? Database - ausgelagert in finder2-db.js ?? */
let DB = (window.FINDER_DB && window.FINDER_DB.length) ? window.FINDER_DB.map(c=>({...c})) : [];

/* Sichert den originalen Stand (aus finder2-db.js) vor jeglicher Admin-Manipulation */
const ORIGINAL_DB = JSON.parse(JSON.stringify(DB));

/* ?? Live DB (loaded from storage, fallback to baked-in) ?? */
let DB_LIVE = [];
const STORAGE_KEY = 'fp_dive_computers';
const LS_KEY = 'fp_admin_db';

async function loadLiveDB() {
  DB_LIVE = DB.map(c => ({...c}));
  try {
    const stored = JSON.parse(localStorage.getItem(LS_KEY) || 'null');
    if (Array.isArray(stored) && stored.length > 0) {
      stored.forEach(sc => {
        const idx = DB_LIVE.findIndex(c => c.id === sc.id);
        if (idx >= 0) {
          if (sc.cu  !== undefined) DB_LIVE[idx].cu  = sc.cu;
          if (sc.af  !== undefined) DB_LIVE[idx].af  = sc.af;
          if (sc.upd !== undefined) DB_LIVE[idx].upd = sc.upd;
          if (sc.hc  !== undefined) DB_LIVE[idx].hc  = !!sc.cu;
          if (sc.p   !== undefined && sc.p > 0) DB_LIVE[idx].p = sc.p;
          // Full model override (new fields added in admin)
          ['n','b','d','g','ai','bat','co','lb','fmt','s'].forEach(k => {
            if (sc[k] !== undefined) DB_LIVE[idx][k] = sc[k];
          });
        } else {
          DB_LIVE.push({...sc});
        }
      });
    }
  } catch(e) { /* localStorage unavailable */ }
}

/* ?? Scoring ?? */
function budgetOk(c,b){const p=c.p;if(b==='<250')return p<=299;if(b==='250-500')return p<=600;if(b==='500-900')return p<=1050;return true;}
function score(c){
  const a=answers;let s=0,max=0;
  // Format: Konsole = hartes Filter
  const cFmt=c.fmt||'wrist-large';
  if(a.fmt==='console'&&cFmt!=='console')return 0;
  if(a.fmt&&a.fmt!=='any'&&a.fmt!=='console'&&cFmt==='console')return 0;
  // Gas: CCR = hartes Filter
  // CCR: hartes Filter auch bei Mehrfachauswahl
  {
    const gases=Array.isArray(a.gas)?a.gas:(a.gas?[a.gas]:[]);
    if(gases.includes('ccr-gas')&&!c.g.includes('ccr-gas'))return 0;
  }
  // Budget: weicher Score - kein hartes 0%, aber starke Gewichtung
  max+=8;
  if(!a.budget||budgetOk(c,a.budget)){s+=8;} // im Budget: volle Punkte
  else {
    // Ueberschreitung: Teilpunkte je nach Grad der Ueberschreitung
    const limits={'<250':299,'250-500':600,'500-900':1050};
    const limit=limits[a.budget]||9999;
    const over=(c.p-limit)/limit; // relative Ueberschreitung
    if(over<0.2)s+=4; // bis 20% drueber: Haelfte
    else if(over<0.5)s+=2; // bis 50% drueber: Viertel
    // >50% drueber: 0 Punkte
  }
  // Tauchstil: Mehrfachauswahl
  if(a.style){
    const styles=Array.isArray(a.style)?a.style:[a.style];
    max+=4;
    const matches=styles.filter(st=>c.s.includes(st)).length;
    s+=Math.round((matches/styles.length)*4);
  }
  max+=3;if(a.display==='any')s+=3;else if(c.d===a.display)s+=3;else if(a.display==='color-watch'&&c.d==='color-large')s+=2;else if(a.display==='color-large'&&c.d==='color-watch')s+=1;
  // Gas: Hierarchie air<nitrox<trimix, Mehrfachauswahl, CCR=hart
  if(a.gas){
    const gases=Array.isArray(a.gas)?a.gas:[a.gas];
    const gl={air:1,nitrox:2,trimix:3,'ccr-gas':4};
    const wantCCR=gases.includes('ccr-gas');
    const hasCCR=c.g.includes('ccr-gas');
    const hg=Math.max(...c.g.map(x=>gl[x]||1));
    if(wantCCR){
      max+=6;if(hasCCR)s+=6;
    } else {
      max+=4;
      const wg=Math.max(...gases.map(g=>gl[g]||1));
      if(hg>=wg)s+=4;
      else if(hg>=wg-1)s+=2;
    }
  }
  max+=3;if(a.airInt==='no')s+=3;else if(c.ai)s+=3;else if(a.airInt==='nice')s+=2;
  max+=2;if(a.battery==='any'||c.bat===a.battery)s+=2;
  max+=3;const wc=a.connect==='high'?3:a.connect==='mid'?2:1;if(c.co>=wc)s+=3;else if(c.co>=wc-1)s+=1;
  if(a.compass==='yes'){max+=2;if(c.compass)s+=2;}
  if(a.gps==='yes'){max+=3;if(c.gps)s+=3;}
  max+=3;const wl=a.logbook==='power'?3:a.logbook==='casual'?2:1;if(c.lb>=wl)s+=3;else if(c.lb>=wl-1)s+=1;
  max+=3;const wu=a.upd==='current'?3:a.upd==='regular'?2:1;if((c.upd||2)>=wu)s+=3;else if((c.upd||2)>=wu-1)s+=1;
  if(a.fmt&&a.fmt!=='any'){
    const cFmt=c.fmt||'wrist-large';
    if(a.fmt==='console'){max+=6;if(cFmt==='console')s+=6;} // Konsole: hart
    else if(cFmt==='console'){max+=6;} // Armband gewaehlt aber Konsole: 0 Punkte
    else{max+=3;if(cFmt===a.fmt)s+=3;else s+=2;} // wrist-large/watch: beide ok, volle Punkte
  }
  return Math.round((s/max)*100);
}

/* ?? Per-criterion match/mismatch for runner cards ?? */
function getCriteriaTags(c){
  const a=answers;const t=T[lang];const L=t.tagLabels;
  const good=[],bad=[];

  if(budgetOk(c,a.budget))good.push(L.budget);
  else bad.push(t.mm.budget(t.mm.bl[a.budget]));

  if(a.style){
    const styles=Array.isArray(a.style)?a.style:[a.style];
    const matches=styles.filter(st=>c.s.includes(st));
    if(matches.length===styles.length)good.push(L.style);
    else if(matches.length>0)good.push(L.style+' (teilw.)');
    else bad.push(t.mm.style(styles.map(st=>t.sL[st]||st).join(', ')));
  }

  if(a.display==='any'||c.d===a.display||(a.display==='color-watch'&&c.d==='color-large'))good.push(L.display);
  else bad.push(t.mm.display(t.dL[c.d]||c.d));

  if(a.gas){
    const gases=Array.isArray(a.gas)?a.gas:[a.gas];
    const gl={air:1,nitrox:2,trimix:3,'ccr-gas':4};
    const wantCCR=gases.includes('ccr-gas');
    const hg=Math.max(...c.g.map(x=>gl[x]||1));
    if(wantCCR){
      if(c.g.includes('ccr-gas'))good.push(L.gas);else bad.push(t.mm.gas);
    } else {
      const wg=Math.max(...gases.map(g=>gl[g]||1));
      if(hg>=wg)good.push(L.gas);else bad.push(t.mm.gas);
    }
  }

  if(a.airInt==='no'||c.ai)good.push(L.airInt);
  else if(a.airInt==='must')bad.push(t.mm.airInt);

  if(a.battery==='any'||c.bat===a.battery)good.push(L.battery);
  else bad.push(a.battery==='usb'?t.mm.battUsb:t.mm.battRepl);

  const wc=a.connect==='high'?3:a.connect==='mid'?2:1;
  if(c.co>=wc)good.push(L.connect);

  if(a.compass==='yes'){if(c.compass)good.push(L.compass);else bad.push(t.mm.compass);}
  if(a.gps==='yes'){if(c.gps)good.push(L.gps);else bad.push(t.mm.gps);}

  const wl=a.logbook==='power'?3:a.logbook==='casual'?2:1;
  if(c.lb>=wl)good.push(L.logbook);

  const wu=a.upd==='current'?3:a.upd==='regular'?2:1;
  if((c.upd||2)>=wu)good.push(L.upd);
  else if(a.upd==='current')bad.push(t.mm.updOld);

  if(a.fmt&&a.fmt!=='any'){
    const cFmt=c.fmt||'wrist-large';
    if(a.fmt==='console'&&cFmt!=='console')bad.push(t.mm.fmt);
    else if(a.fmt!=='console'&&cFmt==='console')bad.push(t.mm.fmt);
    else good.push(L.fmt);
  }

  return {good,bad};
}


/* ?? Overview table ???????????????????????????????????????????????????????? */
let ovVisible = false;

function showOverview(show) {
  ovVisible = show;
  const t = T[lang];
  const steps = document.querySelectorAll('.step');
  steps.forEach(s => s.classList.remove('on'));
  document.getElementById('introBlock').style.display = show ? 'none' : '';
  document.getElementById('progBlock').style.display = 'none';

  if (show) {
    document.getElementById('sOverview').classList.add('on');
    renderOverviewTable();
  } else {
    document.getElementById('s1').classList.add('on');
    document.getElementById('introBlock').style.display = '';
    Object.keys(answers).forEach(k => delete answers[k]);
    document.querySelectorAll('.opt').forEach(b => b.classList.remove('on'));
    for(let i=1;i<=TOTAL;i++){const nb=document.getElementById('n'+i);if(nb)nb.disabled=true;}
    renderAll();
  }
}

function renderOverviewTable() {
  const OV = {
    de: {title:'Alle Tauchcomputer im Vergleich', eyebrow:'Datenbank', back:'<- Zurueck zum Finder', startBtn:'Zum Finder ->', search:'Suchen ...', brand:'Alle Marken',
         cols:['','Modell','Preis','Gas','Luft','Verbind.','Huelle','Kaufen'], cmp:'Vergleichen', noRes:'Keine Ergebnisse',
         disp:{'color-large':'Farbe','color-watch':'Farbe Watch','mono':'Mono'},
         fmt:{'wrist-large':'Armband','wrist-watch':'Watch','console':'Konsole'},
         bat:{usb:'USB','replaceable':'Wechsel'},
         ai:'Luft-Int.',upd:{3:'Aktiv',2:'Gelegentlich',1:'Eingestellt'},
         case:'Huelle ansehen',buy:'Zum Haendler ->',noBuy:'Kein Link',noCase:'Keine Huelle',affNote:'Affiliate-Link - durch deinen Kauf ueber diesen Link unterstuetzt du diese Seite, ohne Mehrkosten fuer dich.',
         stl:{eyebrow:'Tauchcomputer', gas:'Gase', conn:'Verbindung', logbook:'Logbuch', support:'Hersteller-Support',
              rec:'Rekreativ',cold:'Kaltwasser',tech:'Technisch',ccr:'CCR',apnea:'Apnoe',
              good:'Aktiv',fair:'Gelegentlich',old:'Eingestellt'}},
    en: {title:'All Dive Computers Compared', eyebrow:'Database', back:'<- Back to Finder', startBtn:'Open Finder ->', search:'Search ...', brand:'All brands',
         cols:['','Model','Price','Gas','Air','Connect.','Case','Buy'], cmp:'Compare', noRes:'No results',
         disp:{'color-large':'Color','color-watch':'Color Watch','mono':'Mono'},
         fmt:{'wrist-large':'Wrist','wrist-watch':'Watch','console':'Console'},
         bat:{usb:'USB','replaceable':'Swappable'},
         ai:'Air int.',upd:{3:'Active',2:'Occasional',1:'Discontinued'},
         case:'View case',buy:'Shop now ->',noBuy:'No link',noCase:'No case',affNote:'Affiliate link - buying through this link supports this site at no extra cost to you.',
         stl:{eyebrow:'Dive Computer', gas:'Gases', conn:'Connectivity', logbook:'Logbook', support:'Manufacturer Support',
              rec:'Recreational',cold:'Cold Water',tech:'Technical',ccr:'CCR',apnea:'Freediving',
              good:'Active',fair:'Occasional',old:'Discontinued'}},
    es: {title:'Todos los ordenadores comparados', eyebrow:'Base de datos', back:'<- Volver al buscador', startBtn:'Ir al buscador ->', search:'Buscar ...', brand:'Todas las marcas',
         cols:['','Modelo','Precio','Gas','Aire','Conex.','Funda','Comprar'], cmp:'Comparar', noRes:'Sin resultados',
         disp:{'color-large':'Color','color-watch':'Color Watch','mono':'Mono'},
         fmt:{'wrist-large':'Muneca','wrist-watch':'Watch','console':'Consola'},
         bat:{usb:'USB','replaceable':'Pila'},
         ai:'Integr. aire',upd:{3:'Activo',2:'Ocasional',1:'Descatalogado'},
         case:'Ver funda',buy:'Comprar ->',noBuy:'Sin enlace',noCase:'Sin funda',affNote:'Enlace de afiliado - comprando a traves de este enlace apoyas esta pagina sin coste adicional para ti.',
         stl:{eyebrow:'Ordenador de buceo', gas:'Gases', conn:'Conectividad', logbook:'Cuaderno', support:'Soporte fabricante',
              rec:'Recreativo',cold:'Agua fria',tech:'Tecnico',ccr:'CCR',apnea:'Apnea',
              good:'Activo',fair:'Ocasional',old:'Descatalogado'}},
    fr: {title:'Tous les ordinateurs compares', eyebrow:'Base de donnees', back:'<- Retour', startBtn:'Ouvrir ->', search:'Rechercher ...', brand:'Toutes les marques',
         cols:['','Modele','Prix','Gaz','Air','Connex.','Coque','Acheter'], cmp:'Comparer', noRes:'Aucun resultat',
         disp:{'color-large':'Couleur','color-watch':'Couleur Watch','mono':'Mono'},
         fmt:{'wrist-large':'Bracelet','wrist-watch':'Watch','console':'Console'},
         bat:{usb:'USB','replaceable':'Pile'},
         ai:'Integr. air',upd:{3:'Actif',2:'Occasionnel',1:'Discontinue'},
         case:'Voir la coque',buy:'Acheter ->',noBuy:'Pas de lien',noCase:'Pas de coque',affNote:'Lien affilie - en achetant via ce lien vous soutenez ce site sans frais supplementaires.',
         stl:{eyebrow:'Ordinateur de plongee', gas:'Gaz', conn:'Connectivite', logbook:'Carnet', support:'Support fabricant',
              rec:'Recreatif',cold:'Eau froide',tech:'Technique',ccr:'CCR',apnea:'Apnee',
              good:'Actif',fair:'Occasionnel',old:'Discontinue'}},
    it: {title:'Tutti i computer a confronto', eyebrow:'Database', back:'<- Torna', startBtn:'Apri ->', search:'Cerca ...', brand:'Tutti i marchi',
         cols:['','Modello','Prezzo','Gas','Aria','Connett.','Custodia','Acquisto'], cmp:'Confronta', noRes:'Nessun risultato',
         disp:{'color-large':'Colore','color-watch':'Colore Watch','mono':'Mono'},
         fmt:{'wrist-large':'Polso','wrist-watch':'Watch','console':'Console'},
         bat:{usb:'USB','replaceable':'Pila'},
         ai:'Integr. aria',upd:{3:'Attivo',2:'Occasionale',1:'Discontinuato'},
         case:'Vedi custodia',buy:'Acquista ->',noBuy:'Nessun link',noCase:'Nessuna custodia',affNote:'Link affiliato - acquistando tramite questo link supporti questo sito senza costi aggiuntivi per te.',
         stl:{eyebrow:'Computer da immersione', gas:'Gas', conn:'Connettivita', logbook:'Diario', support:'Supporto produttore',
              rec:'Ricreativo',cold:'Acqua fredda',tech:'Tecnico',ccr:'CCR',apnea:'Apnea',
              good:'Attivo',fair:'Occasionale',old:'Discontinuato'}},
  };
  const ov = OV[lang] || OV.de;
  // store labels globally for filterOverview + modal
  window._OV = ov;

  setText('ovEyebrow', ov.eyebrow);
  setText('ovTitle', ov.title);
  setText('ovBack', ov.back);
  setText('ovStartBtn', ov.startBtn);
  const srch = document.getElementById('ovSearch'); if(srch) srch.placeholder = ov.search;
  const ovBtn = document.getElementById('ovLinkBtn');
  if(ovBtn) ovBtn.textContent = '-> ' + ov.eyebrow;

  // Colgroup fuer fixe Spaltenbreiten
  const tbl = document.getElementById('ovTable');
  if(tbl){
    const oldCg = tbl.querySelector('colgroup');
    if(oldCg) oldCg.remove();
    const cg = document.createElement('colgroup');
    [180, 80, 70, 40, 80, 75, 75, 24].forEach(w => {
      const col = document.createElement('col');
      col.style.width = w+'px';
      cg.appendChild(col);
    });
    tbl.insertBefore(cg, tbl.firstChild);
  }
  const head = document.getElementById('ovHead');
  if(head) head.innerHTML = '<tr>' + ov.cols.filter((_,i)=>i!==0).map((c,i) => {
    if(i===0) return `<th style="min-width:140px">${c}</th>`;
    return `<th style="white-space:nowrap">${c}</th>`;
  }).join('') + '</tr>';

  // Brand filter
  const srcDB2 = Array.isArray(DB_LIVE)&&DB_LIVE.length>0?DB_LIVE:DB;
  const brands = [...new Set(srcDB2.map(c => c.b))].sort();
  const brandSel = document.getElementById('ovBrand');
  if(brandSel){
    const cur = brandSel.value;
    brandSel.innerHTML = `<option value="">${ov.brand}</option>` + brands.map(b=>`<option value="${b}"${b===cur?' selected':''}>${b}</option>`).join('');
  }
  filterOverview();
}

/* ?? Gas tags helper ?? */
function _gasLabel(gArr, ov){
  const GAS = {air:'Air/L',nitrox:'Nitrox/N',trimix:'Trimix/T','ccr-gas':'CCR'};
  return (gArr||[]).map(x=>GAS[x]||x).join(' . ');
}
function _gasChips(gArr){
  const GAS = {air:'L',nitrox:'N',trimix:'T','ccr-gas':'CCR'};
  return (gArr||[]).map(x=>`<span style="font-size:10px;font-family:'JetBrains Mono',monospace">${GAS[x]||x}</span>`).join(' ');
}

function filterOverview() {
  const ov = window._OV || {disp:{'color-large':'Farbe','color-watch':'Watch','mono':'Mono'},fmt:{'wrist-large':'Armband','wrist-watch':'Watch','console':'Konsole'},bat:{usb:'USB','replaceable':'Wechsel'},upd:{3:'O',2:'O',1:'O'},noRes:'-'};
  const q = (document.getElementById('ovSearch')||{value:''}).value.toLowerCase();
  const brand = (document.getElementById('ovBrand')||{value:''}).value;
  const GAS_S = {air:'L',nitrox:'N',trimix:'T','ccr-gas':'CCR'};
  const CO_S = {1:'IR',2:'BT',3:'BT+App'};

  const isMobile = window.innerWidth <= 640;
  const tableWrap = document.querySelector('.ov-table-wrap');
  const cardsWrap = document.getElementById('ovCards');
  if(tableWrap) tableWrap.style.display = isMobile ? 'none' : '';
  if(cardsWrap) cardsWrap.style.display = isMobile ? 'flex' : 'none';

  const srcDB = Array.isArray(DB_LIVE)&&DB_LIVE.length>0?DB_LIVE:DB;
  const filtered = srcDB.filter(c => {
    if(q && !c.n.toLowerCase().includes(q) && !c.b.toLowerCase().includes(q)) return false;
    if(brand && c.b !== brand) return false;
    return true;
  }).sort((a,b) => a.b.localeCompare(b.b) || a.n.localeCompare(b.n));

  const countEl = document.getElementById('ovCount');
  if(countEl) countEl.textContent = filtered.length + ' Modelle';

  const noResMsg = ov.noRes || 'Keine Ergebnisse';

  /* ?? Desktop table ?? */
  const body = document.getElementById('ovBody');
  if(body){
    body.innerHTML = filtered.map(c => {
      const dispCls = c.d==='mono'?'mono':'color';
      const dispLabel = ov.disp[c.d]||c.d||'-';
      const gas = (c.g||[]).map(x=>GAS_S[x]||x).join(' ');
      const aiDot = c.ai ? '<span class="ov-dot on"></span>' : '<span class="ov-dot off"></span>';
      const caseCell = c.cu
        ? `<a class="ov-case-link" href="${c.cu}" target="_blank" onclick="event.stopPropagation()">Huelle -></a>`
        : `<span style="color:var(--fp-rule);font-size:11px">-</span>`;
      const buyCell = c.af
        ? `<a class="ov-case-link" href="${c.af}" target="_blank" onclick="event.stopPropagation()" style="color:var(--fp-navy-dk)">Kaufen -></a>`
        : `<span style="color:var(--fp-rule);font-size:11px">-</span>`;
      return `<tr onclick="openSteckbrief('${c.id}')">
        <td style="max-width:180px">
          <div class="ov-name" style="font-size:12px;white-space:normal;line-height:1.3">${c.n}</div>
          <div class="ov-brand-lbl">${c.b}</div>
          <div onclick="event.stopPropagation()" style="margin-top:4px">${_cmpCheckbox(c.id)}</div>
        </td>
        <td style="font-family:'JetBrains Mono',monospace;font-size:12px;white-space:nowrap">${c.p} EUR</td>
        <td style="font-size:11px;font-family:'JetBrains Mono',monospace;white-space:nowrap">${gas}</td>
        <td style="text-align:center">${aiDot}</td>
        <td style="font-size:11px">${CO_S[c.co]||'-'}</td>
        <td>${caseCell}</td>
        <td>${buyCell}</td>
        <td style="text-align:right"><span class="ov-arrow">></span></td>
      </tr>`;
    }).join('') || `<tr><td colspan="8" style="text-align:center;padding:2rem;color:var(--fp-subtle)">${noResMsg}</td></tr>`;
  }

  /* ?? Mobile cards ?? */
  const cards = document.getElementById('ovCards');
  if(cards){
    cards.innerHTML = filtered.map(c => {
      const gas = (c.g||[]).map(x=>GAS_S[x]||x).join(' ');
      const dispLabel = ov.disp[c.d]||c.d||'-';
      const dispCls = c.d==='mono'?'mono':'color';
      const caseChip = c.cu ? `<span class="ov-chip color">Huelle ok</span>` : '';
      return `<div class="ov-card" onclick="openSteckbrief('${c.id}')">
        <div class="ov-card-main">
          <div class="ov-card-name">${c.n}</div>
          <div class="ov-card-sub">${c.b}</div>
          <div class="ov-card-chips">
            <span class="ov-chip fmt">${ov.fmt[c.fmt]||c.fmt||'-'}</span>
            <span class="ov-chip ${dispCls}">${dispLabel}</span>
            <span style="font-size:10px;font-family:'JetBrains Mono',monospace;color:var(--fp-muted)">${gas}</span>
            ${caseChip}
          </div>
        </div>
        <div style="display:flex;flex-direction:column;align-items:flex-end;gap:.4rem;flex-shrink:0">
          <div class="ov-card-price">${c.p} EUR</div>
          ${_cmpCheckbox(c.id)}
        </div>
        <svg class="ov-card-chevron" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 4l4 4-4 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </div>`;
    }).join('') || `<p style="text-align:center;padding:2rem;color:var(--fp-subtle)">${noResMsg}</p>`;
  }
}

/* ?? Steckbrief Modal ?? */
function openSteckbrief(id) {
  const ov = window._OV || {};
  const srcDB = Array.isArray(DB_LIVE)&&DB_LIVE.length>0?DB_LIVE:DB;
  const c = srcDB.find(x => x.id === id);
  if(!c) return;

  const GAS_FULL = {air:'Luft/Air',nitrox:'Nitrox (EAN)',trimix:'Trimix',ccr:'CCR/O2-Steuerung','ccr-gas':'CCR/O2'};
  const CO_FULL = {1:'Kabel/IR',2:'Bluetooth',3:'Bluetooth + App'};
  const UPD_LBL = {3:ov.stl?.good||'Aktiv', 2:ov.stl?.fair||'Gelegentlich', 1:ov.stl?.old||'Eingestellt'};
  const UPD_CLR = {3:'#16a34a',2:'#ca8a04',1:'#ef4444'};
  const STYLE_FULL = {rec:ov.stl?.rec||'Rekreativ',cold:ov.stl?.cold||'Kaltwasser',tech:ov.stl?.tech||'Technisch',ccr:ov.stl?.ccr||'CCR',apnea:ov.stl?.apnea||'Apnoe'};
  const FMT_FULL = ov.fmt||{'wrist-large':'Armband','wrist-watch':'Watch','console':'Konsole'};
  const DISP_FULL = ov.disp||{'color-large':'Farbe (gross)','color-watch':'Farbe Watch','mono':'Monochrom'};
  const BAT_FULL = ov.bat||{usb:'USB-Akku','replaceable':'Wechselbatterie'};

  const styles = (c.s||[]).map(s=>`<span class="tag">${STYLE_FULL[s]||s}</span>`).join('');
  const gases = (c.g||[]).map(g=>`<span class="tag">${GAS_FULL[g]||g}</span>`).join('');
  const stars = '*'.repeat(c.lb||0)+'*'.repeat(3-(c.lb||0));

  // Bild
  const imgSection = c.img ? `
    <div style="width:100%;aspect-ratio:4/3;background:var(--fp-navy-pale);border-radius:var(--r-lg);overflow:hidden;margin-bottom:1.25rem">
      <img src="${c.img}" alt="${c.n}" style="width:100%;height:100%;object-fit:contain;padding:.75rem">
    </div>` : '';

  // Beschreibung
  const descText = c.desc ? (c.desc[lang] || c.desc.de || c.desc.en || '') : '';
  const descSection = descText ? `
    <p style="font-size:13px;line-height:1.65;color:var(--fp-muted);margin-bottom:1.25rem">${descText}</p>
    <div class="modal-divider"></div>` : '';

  const caseSection = c.cu ? `
    <div class="modal-case-box">
      <div class="modal-case-icon">OK</div>
      <div class="modal-case-text"><strong>FrescH-print Huelle verfuegbar</strong>TPU-Schutzhuelle 3D-gedruckt fuer dieses Modell</div>
    </div>
    <a href="${c.cu}" target="_blank" class="modal-btn-case">${ov.case||'Huelle ansehen'}</a>` : `
    <p style="font-size:12px;color:var(--fp-subtle);text-align:center;padding:.5rem 0">${ov.noCase||'Keine Huelle verfuegbar'}</p>`;

  const affSection = c.af
    ? `<div>
        <a href="${c.af}" target="_blank" class="modal-btn-aff">
          * ${ov.buy||'Zum Haendler ->'}
        </a>
        <p style="font-size:10px;color:var(--fp-subtle);text-align:center;margin-top:.4rem;line-height:1.5">
          * ${ov.affNote||'Affiliate-Link - durch deinen Kauf ueber diesen Link unterstuetzt du diese Seite, ohne Mehrkosten fuer dich.'}
        </p>
      </div>`
    : '';

  document.getElementById('modalContent').innerHTML = `
    ${imgSection}
    <div class="modal-eyebrow">${ov.stl?.eyebrow||'Tauchcomputer'}</div>
    <div class="modal-title">${c.n}</div>
    <div class="modal-brand">${c.b}</div>
    <div class="modal-price">${c.p} EUR</div>
    <div class="modal-tags">${styles}</div>
    ${descSection}
    <div class="modal-grid">
      <div class="modal-row"><span class="modal-row-lbl">Format</span><span class="modal-row-val">${FMT_FULL[c.fmt]||c.fmt||'-'}</span></div>
      <div class="modal-row"><span class="modal-row-lbl">Display</span><span class="modal-row-val">${DISP_FULL[c.d]||c.d||'-'}</span></div>
      <div class="modal-row"><span class="modal-row-lbl">Akku</span><span class="modal-row-val">${BAT_FULL[c.bat]||c.bat||'-'}</span></div>
      <div class="modal-row"><span class="modal-row-lbl">${ov.stl?.conn||'Verbindung'}</span><span class="modal-row-val">${CO_FULL[c.co]||'-'}</span></div>
      <div class="modal-row"><span class="modal-row-lbl">Luft-Integration</span><span class="modal-row-val">${c.ai?'&#10003; Ja':'x Nein'}</span></div>
      <div class="modal-row"><span class="modal-row-lbl">Kompass</span><span class="modal-row-val">${c.compass?'&#10003; Ja':'x Nein'}</span></div>
      <div class="modal-row"><span class="modal-row-lbl">GPS</span><span class="modal-row-val">${c.gps?'&#10003; Ja':'x Nein'}</span></div>
      <div class="modal-row"><span class="modal-row-lbl">${ov.stl?.logbook||'Logbuch'}</span><span class="modal-row-val">${stars}</span></div>
    </div>
    <div class="modal-row" style="margin-bottom:.75rem"><span class="modal-row-lbl">${ov.stl?.gas||'Gase'}</span><div style="margin-top:4px">${gases}</div></div>
    <div class="modal-row" style="margin-bottom:1.25rem"><span class="modal-row-lbl">${ov.stl?.support||'Hersteller-Support'}</span><span class="modal-row-val" style="color:${UPD_CLR[c.upd]||'inherit'};font-weight:600">${UPD_LBL[c.upd]||'-'}</span></div>
    <div class="modal-divider"></div>
    ${caseSection}
    ${affSection}
  `;

  document.getElementById('modalBg').classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeSteckbrief() {
  const bg = document.getElementById('modalBg');
  if(bg) bg.classList.remove('open');
  document.body.style.overflow = '';
}

function closeModal(e) {
  if(e.target === e.currentTarget) closeSteckbrief();
}

/* ?? Render ?? */
function setText(id, val){ const el=document.getElementById(id); if(el) el.textContent=val; }

function renderAll(){
  const t=T[lang];
  document.documentElement.lang=lang;
  setText('announceLink', t.announce);
  setText('hChip', t.chip);
  setText('introTag', t.tag);
  setText('introTitle', t.introTitle);
  setText('introSub', t.introSub);
  setText('rTitle', t.resTitle);
  setText('runnersLbl', t.runnersLbl);
  setText('ctaTitle', t.ctaTitle);
  setText('ctaSub', t.ctaSub);
  setText('ctaBtn', t.ctaBtn);
  setText('restartBtn', t.restart);
  const mb1=document.getElementById('missingModelBtn'); if(mb1) mb1.textContent=t.missingBtn||'Modell fehlt?';
  const mb2=document.getElementById('missingModelBtn2'); if(mb2) mb2.textContent=t.missingBtn||'Modell fehlt?';
  const ovBtnEl=document.getElementById('ovLinkBtn');
  if(ovBtnEl){const ovL={de:'-> Alle Modelle',en:'-> All models',es:'-> Todos los modelos',fr:'-> Tous les modeles',it:'-> Tutti i modelli'};
  ovBtnEl.textContent=ovL[lang]||'-> Alle Modelle';}
  document.querySelectorAll('.lb').forEach(b=>b.classList.toggle('on',b.textContent.toLowerCase()===lang));

  t.qs.forEach((q,i)=>{
    const n=i+1;
    setText('q'+n+'c', q.c);
    setText('q'+n+'t', q.t);
    setText('q'+n+'h', q.h);
    // Titelbild-Banner
    const imgEl = document.getElementById('q'+n+'img');
    if(imgEl) {
      const imgUrl = QUESTION_IMAGES[q.k] || '';
      if(imgUrl) {
        imgEl.innerHTML = `<img src="${imgUrl}" alt="${q.c}" style="width:100%;height:300px;object-fit:cover;object-position:center;display:block;border-radius:var(--r-xl) var(--r-xl) 0 0">`;
        imgEl.style.display = '';
      } else {
        imgEl.innerHTML = '';
        imgEl.style.display = 'none';
      }
    }
    // Multi-select hint + class
    const qhint=document.getElementById('q'+n+'hint');
    const stepEl2=document.getElementById('s'+n);
    const isMultiQ=MULTI_KEYS.includes(q.k);
    if(qhint){
      qhint.textContent=isMultiQ?(t.multiHint||'Mehrere Antworten moeglich'):'';
      qhint.style.display=isMultiQ?'block':'none';
    }
    if(stepEl2){
      if(isMultiQ)stepEl2.classList.add('multi-active');
      else stepEl2.classList.remove('multi-active');
    }
    const qo=document.getElementById('q'+n+'o');
    if(qo) {
      const isMulti=MULTI_KEYS.includes(q.k);
      qo.innerHTML=q.o.map(o=>{
        const cur=answers[q.k];
        const isOn=isMulti?(Array.isArray(cur)&&cur.includes(o.v)):(cur===o.v);
        return `<button class="opt${isOn?' on':''}" onclick="pick(this,'${q.k}','${o.v}')">
          <div class="opt-art">${ART[o.a]||''}</div>
          <div class="opt-body">
            <span class="opt-lbl">${o.l}</span>
            <span class="opt-desc">${o.d}</span>
          </div>
        </button>`;
      }).join('');
    }
    const nb=document.getElementById('n'+n);
    if(nb){
      nb.textContent=n<TOTAL?t.next:t.result;
      const cur=answers[q.k];
      const hasAnswer=Array.isArray(cur)?cur.length>0:!!cur;
      nb.disabled=!hasAnswer;
    }
    const bb=document.getElementById('bk'+n);
    if(bb)bb.textContent=t.back;
  });
  const cur=getCurStep();
  if(cur>0&&cur<=TOTAL)updateProg(cur);
  const sResult=document.getElementById('sResult');
  if(sResult&&sResult.classList.contains('on'))showResult();
}

function getCurStep(){for(let i=1;i<=TOTAL;i++){const e=document.getElementById('s'+i);if(e&&e.classList.contains('on'))return i;}return 0;}
function setLang(l){lang=l; if(ovVisible){renderOverviewTable();}else{renderAll();}}

function pick(btn,key,val){
  const isMulti = MULTI_KEYS.includes(key);
  if(isMulti){
    // Toggle: add or remove from array
    if(!Array.isArray(answers[key])) answers[key]=[];
    const idx=answers[key].indexOf(val);
    if(idx>=0){ answers[key].splice(idx,1); btn.classList.remove('on'); }
    else { answers[key].push(val); btn.classList.add('on'); }
    // Enable next button if at least one selected
    const stepEl=btn.closest('.step');
    const n=parseInt(stepEl.id.replace('s',''));
    const nb=document.getElementById('n'+n);
    if(nb) nb.disabled=answers[key].length===0;
  } else {
    btn.closest('.opts').querySelectorAll('.opt').forEach(b=>b.classList.remove('on'));
    btn.classList.add('on');
    answers[key]=val;
    const stepEl=btn.closest('.step');
    const n=parseInt(stepEl.id.replace('s',''));
    const nb=document.getElementById('n'+n);
    if(nb) nb.disabled=false;
    setTimeout(()=>{ if(n>=TOTAL){showResult();}else{goNext(n,n+1);} },300);
  }
}

function updateProg(step){
  const t=T[lang];const pct=Math.round((step/TOTAL)*100);
  const fill=document.getElementById('progFill');if(fill)fill.style.width=pct+'%';
  setText('progLbl',t.prog(step,TOTAL));
  setText('progPct',pct+' %');
}

function goNext(from, _to) {
  const to = from + 1;
  document.getElementById('s'+from).classList.remove('on');
  if (to > TOTAL) { showResult(); return; }
  document.getElementById('s'+to).classList.add('on');
  updateProg(to);
  if (from === 1) {
    document.getElementById('introBlock').style.display = 'none';
    document.getElementById('progBlock').style.display = 'block';
  }
}

function goBack(from, _to) {
  const to = from - 1;
  document.getElementById('s'+from).classList.remove('on');
  document.getElementById('s'+to).classList.add('on');
  updateProg(to);
  if (to === 1) {
    document.getElementById('introBlock').style.display = '';
    document.getElementById('progBlock').style.display = 'none';
  }
}

function showResult(){
  const t=T[lang];
  const source=Array.isArray(DB_LIVE)&&DB_LIVE.length>0?DB_LIVE:DB;
  const ranked=source.map(c=>({...c,pct:score(c)})).filter(c=>c.pct>0).sort((a,b)=>b.pct-a.pct);
  const winner=ranked[0];
  // Falls Gewinner Budget sprengt: beste Budget-konforme Alternative an Position 1 der Runner heben
  let runners=ranked.slice(1,7);
  if(answers.budget&&!budgetOk(winner,answers.budget)){
    const budgetIdx=ranked.findIndex((c,i)=>i>0&&budgetOk(c,answers.budget));
    if(budgetIdx>1){
      const budgetPick=ranked[budgetIdx];
      const rest=ranked.slice(1,7).filter(c=>c.id!==budgetPick.id);
      runners=[budgetPick,...rest].slice(0,6);
    }
  }
  document.getElementById('rSub').textContent=t.resSub(DB.length,Object.keys(answers).length);

  document.getElementById('winnerArea').innerHTML=`
    <div class="winner" onclick="openSteckbrief('${winner.id}')" style="cursor:pointer;position:relative" title="Details anzeigen">
      <div class="w-badge">
        <svg style="width:12px;height:12px;stroke:#fff;fill:none;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round" viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
        ${t.bestMatch}
      </div>
      <div class="w-head">
        <div style="display:flex;align-items:center;gap:1rem;flex:1;min-width:0">
          ${winner.img ? `<img src="${winner.img}" alt="${winner.n}" style="width:72px;height:72px;object-fit:contain;border-radius:10px;background:var(--fp-navy-pale);padding:6px;flex-shrink:0">` : ''}
          <div style="min-width:0">
            <div class="w-name">${winner.n}</div>
            <div class="w-brand">${winner.b} . <span class="price-m">${t.approx} ${winner.p} EUR</span>
              ${winner.hc?`  <span class="case-pill">${t.caseAvail}</span>`:''}
            </div>
          </div>
        </div>
        <div style="display:flex;align-items:center;gap:.75rem">
          <div class="w-score">
            <div style="text-align:right;margin-bottom:4px">${_cmpCheckbox(winner.id)}</div>
            <div class="w-pct">${winner.pct}%</div>
            <div class="w-pct-lbl">${t.matchLbl}</div>
          </div>
          <span style="font-size:18px;color:var(--fp-navy-mid)">></span>
        </div>
      </div>
      <div class="bar-track"><div class="bar-fill" style="width:${winner.pct}%"></div></div>
      ${(()=>{
        const {good,bad}=getCriteriaTags(winner);
        const allRows=[
          ...good.map(g=>`<div style="display:flex;align-items:center;gap:5px;font-size:11px;color:#166534;background:#f0fdf4;border:1px solid #bbf7d0;border-radius:20px;padding:3px 8px;white-space:nowrap"><span style="font-weight:700">&#10003;</span><span>${g}</span></div>`),
          ...bad.map(b=>`<div style="display:flex;align-items:center;gap:5px;font-size:11px;color:#991b1b;background:#fef2f2;border:1px solid #fecaca;border-radius:20px;padding:3px 8px;white-space:nowrap"><span style="font-weight:700">x</span><span>${b}</span></div>`)
        ];
        return `<div style="display:grid;grid-template-columns:1fr 1fr;gap:4px 8px;margin-top:.75rem">${allRows.join('')}</div>`;
      })()}
      ${winner.hc?`<a class="case-lnk" href="${winner.cu}" target="_blank" onclick="event.stopPropagation()">${t.caseLink(winner.n)}</a>`:''}
      ${winner.af?`<div style="margin-top:.75rem">
        <a href="${winner.af}" target="_blank" onclick="event.stopPropagation()" style="display:block;background:var(--fp-navy);color:#fff;text-align:center;padding:.65rem 1rem;border-radius:var(--r-md);font-size:13px;font-weight:700;text-decoration:none">${t.affBuy||'* Jetzt kaufen ->'}</a>
        <p style="font-size:10px;color:var(--fp-subtle);text-align:center;margin-top:.3rem">${t.affNote||'Affiliate-Link - ohne Mehrkosten fuer dich.'}</p>
      </div>`:''}

    </div>`;

  document.getElementById('runnerArea').innerHTML=runners.map(c=>{
    const {good,bad}=getCriteriaTags(c);
    return `<div class="runner" onclick="openSteckbrief('${c.id}')" style="cursor:pointer;position:relative" title="Details anzeigen">
      <div class="r-head">
        <div style="display:flex;align-items:center;gap:.65rem;flex:1;min-width:0">
          ${c.img ? `<img src="${c.img}" alt="${c.n}" style="width:44px;height:44px;object-fit:contain;border-radius:8px;background:var(--fp-navy-pale);padding:4px;flex-shrink:0">` : ''}
          <div style="min-width:0">
            <div class="r-name">${c.n}${c.hc?` <span style="font-size:9px;background:var(--fp-navy-lt);color:var(--fp-navy-dk);padding:1px 5px;border-radius:99px;font-weight:700;border:1px solid var(--fp-navy-mid)">${t.caseBadge}</span>`:''}</div>
            <div class="r-brand">${c.b}</div>
          </div>
        </div>
        <div style="display:flex;flex-direction:column;align-items:flex-end;gap:3px">
          <div style="display:flex;align-items:center;gap:.5rem">
            <div class="r-pct">${c.pct}%</div>
            <span style="font-size:16px;color:var(--fp-rule)">></span>
          </div>
          ${_cmpCheckbox(c.id)}
        </div>
      </div>
      <div class="r-price">${t.approx} ${c.p} EUR</div>
      <div class="bar-track" style="margin-bottom:8px"><div class="bar-fill alt" style="width:${c.pct}%"></div></div>
      <div class="r-tags">
        ${good.map(g=>`<span class="r-tag g">&#10003; ${g}</span>`).join('')}
        ${bad.map(b=>`<span class="r-tag b">x ${b}</span>`).join('')}
      </div>
      ${c.hc?`<div style="margin-top:8px"><a href="${c.cu}" target="_blank" onclick="event.stopPropagation()" style="font-size:10px;color:var(--fp-navy);text-decoration:underline">${t.caseViewLnk}</a></div>`:''}
      ${c.af?`<div style="margin-top:.5rem">
        <a href="${c.af}" target="_blank" onclick="event.stopPropagation()" style="display:block;background:var(--fp-navy);color:#fff;text-align:center;padding:.5rem;border-radius:var(--r-md);font-size:12px;font-weight:600;text-decoration:none">${t.affBuy||'* Kaufen ->'}</a>
        <p style="font-size:9px;color:var(--fp-subtle);text-align:center;margin-top:.25rem">${t.affNote||'Affiliate-Link - ohne Mehrkosten.'}</p>
      </div>`:''}

    </div>`;
  }).join('');

  document.getElementById('s12').classList.remove('on');
  document.getElementById('sResult').classList.add('on');
  document.getElementById('progBlock').style.display='none';
}


/* =========================================================
   COMPARE FEATURE
   ========================================================= */
let cmpSelected = [];

function cmpToggle(id, checked) {
  if (checked) {
    if (cmpSelected.length >= 2) {
      // Deselect oldest, select new
      const old = cmpSelected.shift();
      const oldCb = document.querySelector('.cmp-cb[data-id="' + old + '"]');
      if (oldCb) oldCb.checked = false;
      _markCmpCard(old, false);
    }
    if (!cmpSelected.includes(id)) cmpSelected.push(id);
  } else {
    cmpSelected = cmpSelected.filter(x => x !== id);
  }
  _markCmpCard(id, checked);
  _updateCmpBar();
}

function _markCmpCard(id, on) {
  document.querySelectorAll('.cmp-cb[data-id="' + id + '"]').forEach(cb => { cb.checked = on; });
}

function _updateCmpBar() {
  const bar = document.getElementById('cmpBar');
  const names = document.getElementById('cmpBarNames');
  if (!bar) return;
  const srcDB = Array.isArray(DB_LIVE) && DB_LIVE.length > 0 ? DB_LIVE : DB;
  const labels = cmpSelected.map(id => { const c = srcDB.find(x => x.id === id); return c ? c.n : id; });
  if (cmpSelected.length > 0) {
    bar.classList.add('show');
    names.textContent = labels.join(' vs. ');
  } else {
    bar.classList.remove('show');
  }
}

function clearCompare() {
  cmpSelected.forEach(id => _markCmpCard(id, false));
  cmpSelected = [];
  _updateCmpBar();
}

function openCompare() {
  if (cmpSelected.length < 2) return;
  const srcDB = Array.isArray(DB_LIVE) && DB_LIVE.length > 0 ? DB_LIVE : DB;
  const a = srcDB.find(x => x.id === cmpSelected[0]);
  const b = srcDB.find(x => x.id === cmpSelected[1]);
  if (!a || !b) return;

  const GAS_FULL = {air:'Luft/Air', nitrox:'Nitrox', trimix:'Trimix', 'ccr-gas':'CCR'};
  const CO_FULL = {1:'Kabel/IR', 2:'Bluetooth', 3:'BT + App'};
  const FMT_FULL = {'wrist-large':'Armband gross', 'wrist-watch':'Watch', 'console':'Konsole'};
  const DISP_FULL = {'color-large':'Farbe gross', 'color-watch':'Farbe Watch', mono:'Monochrom'};
  const UPD_FULL = {3:'Aktiv', 2:'Gelegentlich', 1:'Eingestellt'};
  const BAT_FULL = {usb:'USB aufladbar', replaceable:'Wechselakku'};

  function row(label, va, vb) {
    const same = String(va) === String(vb);
    const cls = same ? 'match' : 'diff';
    return '<tr class="' + cls + '"><td class="attr-lbl">' + label + '</td><td>' + va + '</td><td>' + vb + '</td></tr>';
  }

  function header(c) {
    return '<th><div>' +
      (c.img ? '<img class="cmp-hd-img" src="' + c.img + '" alt="' + c.n + '">' : '') +
      '<div class="cmp-hd-name">' + c.n + '</div>' +
      '<div class="cmp-hd-brand">' + c.b + '</div>' +
      '<div class="cmp-hd-price">' + c.p + ' EUR</div>' +
      '</div></th>';
  }

  const gasA = (a.g || []).map(x => GAS_FULL[x] || x).join(', ');
  const gasB = (b.g || []).map(x => GAS_FULL[x] || x).join(', ');
  const styleA = (a.s || []).join(', ');
  const styleB = (b.s || []).join(', ');

  const html =
    '<table class="cmp-tbl">' +
    '<thead><tr><th></th>' + header(a) + header(b) + '</tr></thead>' +
    '<tbody>' +
    row('Preis', a.p + ' EUR', b.p + ' EUR') +
    row('Format', FMT_FULL[a.fmt] || a.fmt || '-', FMT_FULL[b.fmt] || b.fmt || '-') +
    row('Display', DISP_FULL[a.d] || a.d, DISP_FULL[b.d] || b.d) +
    row('Tauchstil', styleA, styleB) +
    row('Gase', gasA, gasB) +
    row('Luftintegration', a.ai ? 'Ja' : 'Nein', b.ai ? 'Ja' : 'Nein') +
    row('Akku', BAT_FULL[a.bat] || a.bat, BAT_FULL[b.bat] || b.bat) +
    row('Konnektivitaet', CO_FULL[a.co] || '-', CO_FULL[b.co] || '-') +
    row('Logbuch', a.lb === 3 ? 'Umfangreich' : a.lb === 2 ? 'Standard' : 'Einfach', b.lb === 3 ? 'Umfangreich' : b.lb === 2 ? 'Standard' : 'Einfach') +
    row('Hersteller-Support', UPD_FULL[a.upd] || '-', UPD_FULL[b.upd] || '-') +
    row('Huelle verfuegbar', a.hc ? 'Ja' : 'Nein', b.hc ? 'Ja' : 'Nein') +
    '</tbody></table>';

  document.getElementById('cmpModalContent').innerHTML = html;
  const bg = document.getElementById('cmpModalBg');
  bg.style.display = 'flex';
  setTimeout(() => bg.classList.add('open'), 10);
}

function closeCmpModal(e) {
  if (e && e.target !== document.getElementById('cmpModalBg')) return;
  const bg = document.getElementById('cmpModalBg');
  bg.classList.remove('open');
  setTimeout(() => { bg.style.display = 'none'; }, 200);
}

function _cmpCheckbox(id) {
  const checked = cmpSelected.includes(id);
  const chk = checked ? ' checked' : '';
  const lbl = (window._OV && window._OV.cmp) ? window._OV.cmp : 'Vergleichen';
  return '<label class="cmp-inline-label" onclick="event.stopPropagation()">' +
    '<input type="checkbox" class="cmp-cb" data-id="' + id + '"' + chk +
    ' onchange="cmpToggle(this.dataset.id, this.checked)">' +
    '<span>' + lbl + '</span>' +
    '</label>';
}


function openMissingModel() {
  const t = T[lang];
  const set = (id, val) => { const el=document.getElementById(id); if(el) el.textContent=val; };
  set('missingFormEyebrow', t.missingEyebrow||'Hinweis senden');
  set('missingFormTitle',   t.missingTitle||'Modell fehlt?');
  set('missingFormSub',     t.missingSub||'Teile uns mit, welches Modell wir ergaenzen sollen.');
  set('missingLblName',     t.missingLblName||'Dein Name');
  set('missingLblModel',    t.missingLblModel||'Modell / Marke');
  set('missingLblMsg',      t.missingLblMsg||'Nachricht (optional)');
  set('missingSubmitBtn',   t.missingSubmit||'E-Mail senden');
  const el = document.getElementById('missingName'); if(el) el.value='';
  const em = document.getElementById('missingModel'); if(em) em.value='';
  const eg = document.getElementById('missingMessage'); if(eg) eg.value='';
  const bg = document.getElementById('missingModalBg');
  if(bg){ bg.style.display='flex'; setTimeout(()=>bg.classList.add('open'),10); }
}

function closeMissingModal() {
  const bg = document.getElementById('missingModalBg');
  if(bg){ bg.classList.remove('open'); setTimeout(()=>{ bg.style.display='none'; },200); }
}

function sendMissingModel() {
  const name  = (document.getElementById('missingName')||{}).value.trim();
  const model = (document.getElementById('missingModel')||{}).value.trim();
  const msg   = (document.getElementById('missingMessage')||{}).value.trim();
  if(!model){ alert('Bitte Modell / Marke eingeben.'); return; }
  const subject = encodeURIComponent('Tauchcomputer-Finder: Modell fehlt - ' + model);
  const body = encodeURIComponent(
    'Hallo,' +
    '\n\nFolgendes Modell fehlt im Tauchcomputer-Finder:\n' +
    'Modell / Marke: ' + model +
    (name ? '\nName: ' + name : '') +
    (msg  ? '\n\nNachricht: ' + msg : '') +
    '\n\n-- Gesendet ueber den Tauchcomputer-Finder auf fresch-print.de'
  );
  window.location.href = 'mailto:info@fresch-print.de?subject=' + subject + '&body=' + body;
  closeMissingModal();
}

function restart(){
  Object.keys(answers).forEach(k=>delete answers[k]);
  document.querySelectorAll('.opt').forEach(b=>b.classList.remove('on'));
  for(let i=1;i<=TOTAL;i++){const nb=document.getElementById('n'+i);if(nb)nb.disabled=true;}
  document.getElementById('sResult').classList.remove('on');
  document.getElementById('s1').classList.add('on');
  document.getElementById('introBlock').style.display='';
  document.getElementById('progBlock').style.display='none';
  document.getElementById('progFill').style.width='12%';
  renderAll();
}

/* ???? ADMIN SCRIPT ???? */

let editingId = null;

// ?? Storage helpers ???????????????????????????????????????????????????????????
function loadDB() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (raw) {
      DB = JSON.parse(raw);
      setStatus('Geladen (' + DB.length + ' Modelle)', true);
    } else {
      DB = JSON.parse(JSON.stringify(ORIGINAL_DB));
      saveDB();
      setStatus('Initialisiert mit finder2.js Daten', true);
    }
  } catch(e) {
    DB = JSON.parse(JSON.stringify(ORIGINAL_DB));
    setStatus('Fehler - finder2.js Daten geladen', false);
  }
  renderAdminAll();
}

function saveDB() {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(DB));
    toast('ok Gespeichert');
  } catch(e) {
    toast('Fehler Speichern fehlgeschlagen');
  }
}

function setStatus(txt, ok) {
  document.getElementById('statusTxt').textContent = txt;
  document.getElementById('statusDot').style.background = ok ? '#4ade80' : '#f87171';
}

function loadFromFinderDB() {
  if (!confirm('Wirklich alle Admin-Daten mit dem aktuellen Stand aus der finder2.js ueberschreiben? Ungespeicherte Admin-Aenderungen gehen verloren.')) return;
  
  DB = JSON.parse(JSON.stringify(ORIGINAL_DB));
  saveDB();
  renderAdminAll();
  toast('ok Aktuelle Daten aus finder2.js geladen!');
}

async function loadFromLiveServer() {
  const btn = document.getElementById('btnLiveLoad');
  const statusEl = document.getElementById('liveLoadStatus');
  if (!confirm('Live-DB von fresch-print.de/assets/finder2.js laden? Ungespeicherte Aenderungen werden ueberschrieben.')) return;

  if (btn) { btn.disabled = true; btn.textContent = 'Laden...'; }
  if (statusEl) { statusEl.textContent = ''; statusEl.style.color = ''; }

  try {
    // CDN-URL der finder2-db.js aus dem Script-Tag lesen
    const dbScriptTag = Array.from(document.querySelectorAll('script[src]'))
      .find(s => s.src.includes('finder2-db'));
    if (!dbScriptTag) throw new Error('finder2-db.js Script-Tag nicht gefunden');
    const url = dbScriptTag.src.split('?')[0] + '?v=' + Date.now();
    const res = await fetch(url);
    if (!res.ok) throw new Error('HTTP ' + res.status);
    const text = await res.text();

    // window.FINDER_DB_VERSION lesen
    const vMatch = text.match(/FINDER_DB_VERSION\s*=\s*'([^']+)'/);
    const liveVersion = vMatch ? vMatch[1] : 'unbekannt';

    // window.FINDER_DB Array extrahieren per Klammerzaehler
    const dbStart = text.search(/FINDER_DB\s*=\s*\n?\s*\[/);
    if (dbStart === -1) throw new Error('DB-Block nicht gefunden');
    const arrStart = text.indexOf('[', dbStart);
    let depth = 0, arrEnd = -1;
    for (let i = arrStart; i < text.length; i++) {
      const ch = text[i];
      if (ch === '[') depth++;
      else if (ch === ']') { depth--; if (depth === 0) { arrEnd = i; break; } }
    }
    if (arrEnd === -1) throw new Error('DB-Block Ende nicht gefunden');
    const dbText = text.slice(arrStart, arrEnd + 1);
    const parsed = (new Function('return ' + dbText))();
    if (!Array.isArray(parsed) || parsed.length === 0) throw new Error('Leeres Array');

    DB = parsed;
    saveDB();
    renderAdminAll();

    const msg = 'Live-DB geladen: ' + DB.length + ' Modelle (Version ' + liveVersion + ')';
    setStatus(msg, true);
    if (statusEl) { statusEl.textContent = msg; statusEl.style.color = '#166534'; }
    toast('ok ' + DB.length + ' Modelle von Live-Server geladen');
  } catch(err) {
    const msg = 'Fehler: ' + err.message;
    setStatus(msg, false);
    if (statusEl) { statusEl.textContent = msg; statusEl.style.color = '#991B1B'; }
    toast('Fehler ' + err.message);
  } finally {
    if (btn) { btn.disabled = false; btn.textContent = 'Live-DB laden'; }
  }
}


// ?? Render ????????????????????????????????????????????????????????????????????
const DISP_L = {'color-large':'Farbe gross','color-watch':'Farbe Watch','mono':'Monochrom'};
const FMT_L={'console':'Konsole','wrist-large':'Handgelenk gross','wrist-watch':'Watch'};
const UPD_L = {3:'Aktiv',2:'Gelegentlich',1:'Eingestellt'};
const UPD_CLS = {3:'upd-3',2:'upd-2',1:'upd-1'};
const GAS_SHORT = {air:'Luft',nitrox:'Nitrox',trimix:'Trimix','ccr-gas':'CCR'};

function yesNo(v) {
  return v ? '<span class="attr-dot dot-yes"></span>' : '<span class="attr-dot dot-no"></span>';
}

function linkBtn(url, label) {
  if (!url) return '<span style="color:var(--subtle);font-size:11px">-</span>';
  return `<a href="${url}" target="_blank" style="font-size:11px;color:var(--navy);text-decoration:underline;white-space:nowrap" title="${url}">${label} -></a>`;
}

function renderAdminAll() {
  renderDashboard();
  renderTable();
  renderOverview();
  renderBrandFilter();
  updateCount();
  renderQuestionImages();
}

function renderQuestionImages() {
  const container = document.getElementById('qImgList');
  if(!container) return;
  const LABELS = {
    budget:'Budget', style:'Tauchstil', fmt:'Format', display:'Display',
    gas:'Gasmanagement', airInt:'Luftintegration', battery:'Akku',
    connect:'Konnektivitaet', compass:'Kompass', gps:'GPS', logbook:'Logbuch & Software', upd:'Aktualitaet'
  };
  container.innerHTML = Q_KEYS.map(k => `
    <div style="margin-bottom:1rem">
      <label style="font-size:12px;font-weight:600;color:var(--subtle);display:block;margin-bottom:4px">${LABELS[k]||k}</label>
      <div style="display:flex;gap:.5rem;align-items:center">
        <input type="text" id="qimg-${k}" value="${QUESTION_IMAGES[k]||''}"
          placeholder="https://..."
          style="flex:1;font-family:inherit;font-size:12px;padding:6px 10px;border:1px solid var(--rule);border-radius:var(--r);background:var(--white)"
          oninput="previewQImg('${k}')">
        ${QUESTION_IMAGES[k] ? `<img src="${QUESTION_IMAGES[k]}" style="width:48px;height:36px;object-fit:cover;border-radius:4px;border:1px solid var(--rule)" id="qimgprev-${k}">` : `<div id="qimgprev-${k}" style="width:48px;height:36px;background:var(--navy-pale);border-radius:4px;border:1px solid var(--rule)"></div>`}
      </div>
    </div>`).join('');
}

function previewQImg(k) {
  const url = document.getElementById('qimg-'+k)?.value.trim();
  const prev = document.getElementById('qimgprev-'+k);
  if(!prev) return;
  if(url) { prev.outerHTML = `<img src="${url}" style="width:48px;height:36px;object-fit:cover;border-radius:4px;border:1px solid var(--rule)" id="qimgprev-${k}">`; }
  else { prev.outerHTML = `<div id="qimgprev-${k}" style="width:48px;height:36px;background:var(--navy-pale);border-radius:4px;border:1px solid var(--rule)"></div>`; }
}

function saveQuestionImagesAdmin() {
  Q_KEYS.forEach(k => {
    const val = document.getElementById('qimg-'+k)?.value.trim() || '';
    if(val) QUESTION_IMAGES[k] = val;
    else delete QUESTION_IMAGES[k];
  });
  saveQuestionImages();
  toast('ok Fragen-Bilder gespeichert');
}

function renderDashboard() {
  const total = DB.length;
  const withCase = DB.filter(c => c.cu).length;
  const withAff = DB.filter(c => c.af).length;
  const active = DB.filter(c => c.upd === 3).length;
  document.getElementById('dTotal').textContent = total;
  document.getElementById('dWithCase').textContent = withCase;
  document.getElementById('dWithAffiliate').textContent = withAff;
  document.getElementById('dActive').textContent = active;

  const rows = [...DB].sort((a,b) => a.n.localeCompare(b.n)).map(c => `
    <tr>
      <td>
        <div style="display:flex;align-items:center;gap:10px">
          ${c.img
            ? `<img src="${c.img}" alt="${c.n}" style="width:40px;height:40px;object-fit:contain;border-radius:6px;background:#f4f6fa;padding:3px;flex-shrink:0">`
            : `<div style="width:40px;height:40px;border-radius:6px;background:#f4f6fa;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:18px">?</div>`
          }
          <div><div class="tbl-name">${c.n}</div><div class="tbl-brand">${c.b}</div></div>
        </div>
      </td>
      <td>${c.cu ? `<span class="badge badge-g">ok Huelle</span>` : `<span class="badge badge-r">Fehlt</span>`}</td>
      <td>${c.af ? `<span class="badge badge-g">ok Link</span>` : `<span class="badge badge-a">Fehlt</span>`}</td>
      <td><span class="badge ${UPD_CLS[c.upd]}">${UPD_L[c.upd]||'-'}</span></td>
      <td>
        <div style="display:flex;gap:6px;align-items:center">
          <button class="btn btn-sm" onclick="openModal('${c.id}')">Bearbeiten</button>
          <button class="btn btn-sm" onclick="copyQAPrompt('${c.id}')" style="background:#eff6ff;color:#1d4ed8;border-color:#bfdbfe" title="Daten pruefen - in Zwischenablage kopieren">Pruefen</button>
          <button class="btn btn-sm" onclick="deleteComputer('${c.id}')" style="background:#fee2e2;color:#991b1b;border-color:#fecaca" title="Loeschen">x</button>
        </div>
      </td>
    </tr>`).join('');
  document.getElementById('dashTable').innerHTML = rows;
}


function copyQAPrompt(id) {
  const c = DB.find(x => x.id === id);
  if (!c) return;

  const FMT_FULL = {'console':'Konsole (konsolenfoermig, gross)','wrist-large':'Handgelenk, gross (ab 2.2 Zoll)','wrist-watch':'Smartwatch-Format (kompakt, bis 1.6 Zoll)'};
  const DISP_FULL = {'color-large':'Farbe, grosses Display','color-watch':'Farbe, kompakt (Watch)','mono':'Monochrom'};
  const GAS_FULL = {'air':'Luft','nitrox':'Nitrox','trimix':'Trimix','ccr-gas':'CCR / O2'};
  const STYLE_FULL = {'rec':'Recreational','cold':'Kaltwasser','tech':'Technisch','ccr':'CCR','apnea':'Apnoe'};
  const BAT_FULL = {'usb':'USB aufladbar','replaceable':'Wechselbatterie'};
  const CO_FULL = {'1':'1 - Kabel/IR (kein Bluetooth)','2':'2 - Bluetooth','3':'3 - Bluetooth + App + Cloud'};
  const LB_FULL = {'1':'1 - Basis','2':'2 - Mittel','3':'3 - Detailliert + PC-Software'};
  const UPD_FULL = {'1':'1 - Eingestellt / Legacy (keine Updates mehr)','2':'2 - Gelegentlich (sporadische Updates)','3':'3 - Aktiv (regelmaessige Updates)'};

  const dataBlock = [
    '=== TAUCHCOMPUTER-DATENSATZ ZUR PRUEFUNG ===',
    '',
    'Modell:            ' + c.n,
    'Marke:             ' + c.b,
    'Interne ID:        ' + c.id,
    'Preis (EUR UVP):   ' + (c.p ? c.p + ' EUR' : 'nicht angegeben'),
    '',
    'Format:            ' + (FMT_FULL[c.fmt] || c.fmt || 'nicht angegeben'),
    'Display:           ' + (DISP_FULL[c.d] || c.d || 'nicht angegeben'),
    '',
    'Gasmanagement:     ' + (c.g && c.g.length ? c.g.map(x => GAS_FULL[x] || x).join(', ') : 'nicht angegeben'),
    'Tauchstile:        ' + (c.s && c.s.length ? c.s.map(x => STYLE_FULL[x] || x).join(', ') : 'nicht angegeben'),
    '',
    'Luftintegration:   ' + (c.ai ? 'Ja' : 'Nein'),
    'Kompass (digital): ' + (c.compass ? 'Ja' : 'Nein'),
    'GPS:               ' + (c.gps ? 'Ja' : 'Nein'),
    '',
    'Akku:              ' + (BAT_FULL[c.bat] || c.bat || 'nicht angegeben'),
    'Konnektivitaet:    ' + (CO_FULL[String(c.co)] || c.co || 'nicht angegeben'),
    'Logbuch-Tiefe:     ' + (LB_FULL[String(c.lb)] || c.lb || 'nicht angegeben'),
    'Aktualitaet:       ' + (UPD_FULL[String(c.upd)] || c.upd || 'nicht angegeben'),
    '',
    'Huelle-Link:       ' + (c.cu || 'kein Link'),
    'Affiliate-Link:    ' + (c.af || 'kein Link'),
    'Produktbild-URL:   ' + (c.img || 'kein Bild'),
    '',
    'Beschreibung (DE): ' + (c.desc && c.desc.de ? c.desc.de : 'nicht angegeben'),
    'Beschreibung (EN): ' + (c.desc && c.desc.en ? c.desc.en : 'nicht angegeben'),
    '',
    '=== PRUEFAUFTRAG ===',
    '',
    'Bitte pruefe die obigen technischen Daten fuer den Tauchcomputer "' + c.n + '" auf Korrektheit.',
    'Vergleiche sie mit oeffentlich verfuegbaren Herstellerangaben und Fachquellen.',
    '',
    'Pruefe insbesondere:',
    '- Ist der angegebene Preis realistisch fuer dieses Modell (EUR UVP)?',
    '- Stimmt das Gasmanagement (unterstuetzte Gase und Modi)?',
    '- Ist die Aussage zur Luftintegration korrekt?',
    '- Hat dieses Modell einen integrierten digitalen Kompass (Ja/Nein)?',
    '- Hat dieses Modell einen integrierten GPS-Empfaenger (Ja/Nein)?',
    '- Stimmt der Akkutyp (USB aufladbar vs. Wechselbatterie)?',
    '- Ist das Format / die Gehaeusekategorie korrekt eingestuft?',
    '- Sind die angegebenen Tauchstile plausibel?',
    '- Ist die Aktualitaet / Support-Einstufung aktuell korrekt?',
    '',
    'Antworte bitte strukturiert: zuerst bestaetigen was korrekt ist, dann konkrete Fehler oder Unklarheiten benennen, und schliesslich Korrekturvorschlaege machen.',
  ].join('\n');

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(dataBlock).then(() => {
      toast('Pruef-Prompt fuer "' + c.n + '" in Zwischenablage kopiert!');
    }).catch(() => {
      fallbackCopyQA(dataBlock, c.n);
    });
  } else {
    fallbackCopyQA(dataBlock, c.n);
  }
}

function fallbackCopyQA(text, name) {
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px';
  document.body.appendChild(ta);
  ta.select();
  try {
    document.execCommand('copy');
    toast('Pruef-Prompt fuer "' + name + '" kopiert!');
  } catch(e) {
    toast('Kopieren fehlgeschlagen - bitte manuell kopieren.');
  }
  document.body.removeChild(ta);
}
function renderTable() {
  var _si = document.getElementById('searchInput');
  var _fb = document.getElementById('filterBrand');
  var _fu = document.getElementById('filterUpd');
  var _fc = document.getElementById('filterCase');
  const q = _si ? _si.value.toLowerCase() : '';
  const brand = _fb ? _fb.value : '';
  const upd = _fu ? _fu.value : '';
  const caseF = _fc ? _fc.value : '';

  const filtered = DB.filter(c => {
    if (q && !c.n.toLowerCase().includes(q) && !c.b.toLowerCase().includes(q)) return false;
    if (brand && c.b !== brand) return false;
    if (upd && String(c.upd) !== upd) return false;
    if (caseF === 'yes' && !c.cu) return false;
    if (caseF === 'no' && c.cu) return false;
    return true;
  }).sort((a,b) => a.n.localeCompare(b.n));

  const rows = filtered.map(c => `
    <tr>
      <td><div class="tbl-name">${c.n}</div><div class="tbl-brand">${c.b}</div></td>
      <td style="font-family:'IBM Plex Mono',monospace">${c.p} EUR</td>
      <td><span class="badge badge-n">${FMT_L[c.fmt]||c.fmt||'-'}</span></td>
      <td><span class="badge badge-n">${DISP_L[c.d]||c.d}</span></td>
      <td style="font-size:11px">${c.g.map(x=>GAS_SHORT[x]||x).join(', ')}</td>
      <td>${yesNo(c.ai)}</td>
      <td style="font-size:11px">${c.bat==='usb'?'USB':'Wechsel'}</td>
      <td><span class="badge ${UPD_CLS[c.upd]}">${UPD_L[c.upd]||'-'}</span></td>
      <td>${c.cu ? `<a href="${c.cu}" target="_blank" class="badge badge-g" style="text-decoration:none">ok</a>` : `<span class="badge badge-r">-</span>`}</td>
      <td>${c.af ? `<a href="${c.af}" target="_blank" class="badge badge-g" style="text-decoration:none">ok</a>` : `<span class="badge badge-a">-</span>`}</td>
      <td style="white-space:nowrap">
        <button class="btn btn-sm" onclick="openModal('${c.id}')" title="Bearbeiten" style="padding:5px 9px;font-size:14px">Edit</button>
        <button class="btn btn-sm" onclick="copyQAPrompt('${c.id}')" title="Daten pruefen - in Zwischenablage" style="padding:5px 9px;font-size:14px;background:#eff6ff;color:#1d4ed8;border-color:#bfdbfe">Pruefen</button>
        <button class="btn btn-sm btn-danger" onclick="deleteComputer('${c.id}')" title="Loeschen" style="padding:5px 9px;font-size:14px">Del</button>
      </td>
    </tr>`).join('');
  document.getElementById('computerTable').innerHTML = rows || '<tr><td colspan="10" class="empty">Keine Ergebnisse</td></tr>';
}

function renderOverview() {
  const STYLE_L = {rec:'Rec',cold:'Kalt',tech:'Tech',ccr:'CCR',apnea:'Apnoe'};
  const CO_L = {1:'Kabel',2:'BT',3:'BT+App'};

  const rows = [...DB].sort((a,b) => a.b.localeCompare(b.b)||a.n.localeCompare(b.n)).map(c => `
    <tr>
      <td><div class="tbl-name" style="white-space:nowrap">${c.n}</div></td>
      <td style="font-size:11px;white-space:nowrap">${c.b}</td>
      <td style="font-family:'IBM Plex Mono',monospace;font-size:12px">${c.p} EUR</td>
      <td><span class="badge badge-n" style="font-size:10px">${DISP_L[c.d]||c.d}</span></td>
      <td style="font-size:11px;white-space:nowrap">${c.g.map(x=>GAS_SHORT[x]||x).join(' . ')}</td>
      <td style="text-align:center">${yesNo(c.ai)}</td>
      <td style="font-size:11px">${c.bat==='usb'?'USB':'Wechsel'}</td>
      <td style="font-size:11px">${CO_L[c.co]||c.co}</td>
      <td style="text-align:center">
        ${'*'.repeat(c.lb)}${'*'.repeat(3-c.lb)}
      </td>
      <td><span class="badge ${UPD_CLS[c.upd]}" style="font-size:10px">${UPD_L[c.upd]||'-'}</span></td>
      <td>${linkBtn(c.cu, 'Huelle')}</td>
      <td>${linkBtn(c.af, 'Kaufen')}</td>
    </tr>`).join('');
  document.getElementById('overviewBody').innerHTML = rows;
}

function renderBrandFilter() {
  const brands = [...new Set(DB.map(c => c.b))].sort();
  const sel = document.getElementById('filterBrand'); if (!sel) return;
  const cur = sel.value;
  sel.innerHTML = '<option value="">Alle Marken</option>' + brands.map(b => `<option value="${b}"${b===cur?'selected':''}>${b}</option>`).join('');
}

function updateCount() {
  var cc = document.getElementById('countComputers'); if (cc) cc.textContent = DB.length;
}

function renderJsonPreview() {
  var el = document.getElementById('jsonPreview');
  if (el) el.value = JSON.stringify(DB, null, 2);
}

// ?? Modal ?????????????????????????????????????????????????????????????????????
function openModal(id) {
  editingId = id || null;
  const c = id ? DB.find(x => x.id === id) : null;
  document.getElementById('modalTitle').textContent = c ? `Bearbeiten: ${c.n}` : 'Neuer Tauchcomputer';

  document.getElementById('f-name').value = c ? c.n : '';
  document.getElementById('f-brand').value = c ? c.b : '';
  document.getElementById('f-price').value = c ? c.p : '';
  document.getElementById('f-display').value = c ? c.d : 'color-large';
  document.getElementById('f-airInt').value = c ? String(c.ai) : 'false';
  const fComp = document.getElementById('f-compass'); if(fComp) fComp.value = c ? String(c.compass||false) : 'false';
  const fGps = document.getElementById('f-gps'); if(fGps) fGps.value = c ? String(c.gps||false) : 'false';
  document.getElementById('f-format').value = c ? (c.fmt||'wrist-large') : 'wrist-large';
  document.getElementById('f-battery').value = c ? c.bat : 'usb';
  document.getElementById('f-connect').value = c ? String(c.co) : '2';
  document.getElementById('f-logbook').value = c ? String(c.lb) : '2';
  document.getElementById('f-upd').value = c ? String(c.upd) : '3';
  document.getElementById('f-caseUrl').value = c ? (c.cu||'') : '';
  document.getElementById('f-affiliateUrl').value = c ? (c.af||'') : '';
  document.getElementById('f-imgUrl').value = c ? (c.img||'') : '';
  document.getElementById('f-desc-de').value = c ? (c.desc?.de||'') : '';
  document.getElementById('f-desc-en').value = c ? (c.desc?.en||'') : '';
  document.getElementById('f-desc-es').value = c ? (c.desc?.es||'') : '';
  document.getElementById('f-desc-fr').value = c ? (c.desc?.fr||'') : '';
  document.getElementById('f-desc-it').value = c ? (c.desc?.it||'') : '';
  document.getElementById('f-id').value = c ? c.id : '';

  // Multi-selects
  const gasOpts = document.getElementById('f-gas').options;
  const gasArr = c ? c.g : ['air','nitrox'];
  for (let o of gasOpts) o.selected = gasArr.includes(o.value);

  const styleOpts = document.getElementById('f-styles').options;
  const styleArr = c ? c.s : ['rec'];
  for (let o of styleOpts) o.selected = styleArr.includes(o.value);

  // Bild-Vorschau
  _updateImgPreview();
  document.getElementById('f-imgUrl').oninput = _updateImgPreview;

  document.getElementById('adminModalBg').classList.add('open');
}

function _updateImgPreview() {
  const url = (document.getElementById('f-imgUrl')||{value:''}).value.trim();
  const preview = document.getElementById('f-imgPreview');
  const img = document.getElementById('f-imgPreviewImg');
  if(!preview || !img) return;
  if(url) {
    img.src = url;
    preview.style.display = 'block';
  } else {
    preview.style.display = 'none';
  }
}

function closeModal(e) {
  if (e && e.target !== document.getElementById('adminModalBg')) return;
  document.getElementById('adminModalBg').classList.remove('open');
  editingId = null;
}

function saveComputer() {
  const name = document.getElementById('f-name').value.trim();
  const brand = document.getElementById('f-brand').value.trim();
  if (!name || !brand) { toast('Name und Marke sind Pflichtfelder'); return; }

  const gas = [...document.getElementById('f-gas').selectedOptions].map(o => o.value);
  const styles = [...document.getElementById('f-styles').selectedOptions].map(o => o.value);

  let id = document.getElementById('f-id').value.trim() ||
    (brand + '-' + name).toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');

  const entry = {
    id, n:name, b:brand,
    p: parseInt(document.getElementById('f-price').value)||0,
    s: styles.length ? styles : ['rec'],
    d: document.getElementById('f-display').value,
    g: gas.length ? gas : ['air'],
    ai: document.getElementById('f-airInt').value === 'true',
    compass: (document.getElementById('f-compass')||{value:'false'}).value === 'true',
    gps: (document.getElementById('f-gps')||{value:'false'}).value === 'true',
    fmt: document.getElementById('f-format').value,
    bat: document.getElementById('f-battery').value,
    co: parseInt(document.getElementById('f-connect').value),
    lb: parseInt(document.getElementById('f-logbook').value),
    upd: parseInt(document.getElementById('f-upd').value),
    hc: !!document.getElementById('f-caseUrl').value.trim(),
    cu: document.getElementById('f-caseUrl').value.trim(),
    af: document.getElementById('f-affiliateUrl').value.trim(),
    img: document.getElementById('f-imgUrl').value.trim(),
    desc: {
      de: document.getElementById('f-desc-de').value.trim(),
      en: document.getElementById('f-desc-en').value.trim(),
      es: document.getElementById('f-desc-es').value.trim(),
      fr: document.getElementById('f-desc-fr').value.trim(),
      it: document.getElementById('f-desc-it').value.trim(),
    },
    _updated: new Date().toISOString()
  };

  if (editingId) {
    const idx = DB.findIndex(x => x.id === editingId);
    if (idx >= 0) DB[idx] = entry;
  } else {
    if (DB.find(x => x.id === id)) { toast('ID existiert bereits - bitte aendern'); return; }
    DB.push(entry);
  }

  saveDB();
  document.getElementById('adminModalBg').classList.remove('open');
  renderAdminAll();
}

function deleteComputer(id) {
  const c = DB.find(x => x.id === id);
  if (!confirm(`"${c?.n}" wirklich loeschen?`)) return;
  DB = DB.filter(x => x.id !== id);
  saveDB();
  renderAdminAll();
}

// ?? Import / Export ???????????????????????????????????????????????????????????
function exportData() {
  const blob = new Blob([JSON.stringify(DB, null, 2)], {type:'application/json'});
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = 'fresch-print-computers.json';
  a.click();
}

function generateDBFile() {
  var now = new Date();
  var pad = function(n){return String(n).padStart(2,'0');};
  var today = now.getFullYear() + '-' + pad(now.getMonth()+1) + '-' + pad(now.getDate())
    + '-' + pad(now.getHours()) + '-' + pad(now.getMinutes());
  var nl = String.fromCharCode(10);
  var rows = DB.map(function(c) {
    var g = JSON.stringify(c.g);
    var s = JSON.stringify(c.s);
    var desc = c.desc ? ',desc:' + JSON.stringify(c.desc) : '';
    var img  = c.img  ? ',img:'  + JSON.stringify(c.img)  : '';
    var cu   = c.cu   ? ',cu:'   + JSON.stringify(c.cu)   : ',cu:""';
    var af   = c.af   ? ',af:'   + JSON.stringify(c.af)   : ',af:""';
    return '  {id:' + JSON.stringify(c.id)
      + ',n:'  + JSON.stringify(c.n)
      + ',b:'  + JSON.stringify(c.b)
      + ',p:'  + c.p
      + ',s:'  + s
      + ',d:'  + JSON.stringify(c.d)
      + ',g:'  + g
      + ',ai:' + c.ai
      + ',bat:'+ JSON.stringify(c.bat)
      + ',co:' + c.co
      + ',lb:' + c.lb
      + ',upd:'+ c.upd
      + ',hc:' + c.hc
      + ',compass:' + (c.compass||false)
      + ',gps:' + (c.gps||false)
      + ',fmt:'+ JSON.stringify(c.fmt)
      + cu + af + img + desc
      + '}';
  }).join(',' + nl);
  var fieldDoc = '/*' + nl
    + ' * FELDBESCHREIBUNG / FIELD REFERENCE' + nl
    + ' *' + nl
    + ' * id         {string}   Eindeutige ID (z.B. "garmin-mk3i")' + nl
    + ' * n          {string}   Modellname (z.B. "Garmin Descent Mk3i")' + nl
    + ' * b          {string}   Marke / Hersteller' + nl
    + ' * p          {number}   Preis in EUR (UVP-Richtwert, Strassenpreis liegt oft darunter)' + nl
    + ' * s          {array}    Tauchstile: rec=Recreational, cold=Kaltwasser, tech=Technisch, ccr=Rebreather, apnea=Apnoe' + nl
    + ' * d          {string}   Display: color-large=Farbe gross, color-watch=Farbe Watch, mono=Monochrom' + nl
    + ' * g          {array}    Gase: air=Luft, nitrox=Nitrox, trimix=Trimix, ccr-gas=CCR' + nl
    + ' * ai         {boolean}  Luftintegration (Transmitter fuer Tankdruck)' + nl
    + ' * compass    {boolean}  Digitaler Kompass integriert' + nl
    + ' * gps        {boolean}  GPS-Empfaenger integriert' + nl
    + ' * bat        {string}   Akku: usb=USB-aufladbar, replaceable=Wechselakku' + nl
    + ' * co         {number}   Konnektivitaet: 1=Kabel/IR, 2=Bluetooth, 3=Bluetooth+App' + nl
    + ' * lb         {number}   Logbuch: 1=Einfach, 2=Standard, 3=Umfangreich' + nl
    + ' * upd        {number}   Hersteller-Support: 1=Eingestellt, 2=Gelegentlich, 3=Aktiv' + nl
    + ' * hc         {boolean}  Huelle/Schutzcover verfuegbar (wird automatisch aus cu gesetzt)' + nl
    + ' * fmt        {string}   Format: wrist-large=Armband gross, wrist-watch=Watch, console=Konsole' + nl
    + ' * cu         {string}   URL zur passenden Huelle auf fresch-print.de (leer = keine)' + nl
    + ' * af         {string}   Affiliate-Link (Amazon o.ae.), mit * markiert im Finder' + nl
    + ' * img        {string}   Produktbild-URL (Amazon CDN oder Shopify CDN)' + nl
    + ' * desc       {object}   Kurzbeschreibung in 5 Sprachen: de, en, es, fr, it' + nl
    + ' */' + nl;
  var header = fieldDoc
    + '/* FrescH-print Tauchcomputer-Datenbank */' + nl
    + '/* DB_VERSION: bei jedem Upload hier das Datum aktualisieren */' + nl;
  var version = 'window.FINDER_DB_VERSION = \'' + today + '\';' + nl + nl;
  var fileContent = header + version + 'window.FINDER_DB =' + nl + '[' + nl + rows + nl + '];' + nl;
  var blob = new Blob([fileContent], {type: 'application/javascript'});
  var a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = 'finder2-db.js';
  a.click();
  toast('ok finder2-db.js erzeugt - ' + DB.length + ' Modelle');
}


async function importData(e) {
  const file = e.target.files[0];
  if (!file) return;
  const text = await file.text();
  try {
    const parsed = JSON.parse(text);
    if (!Array.isArray(parsed)) throw new Error('Kein Array');
    DB = parsed;
    saveDB();
    renderAdminAll();
    toast('ok Import erfolgreich - ' + DB.length + ' Modelle');
  } catch(err) {
    toast('Fehler Ungueltiges JSON: ' + err.message);
  }
  e.target.value = '';
}

// ?? Nav ???????????????????????????????????????????????????????????????????????
function showPage(name) {
  document.querySelectorAll('.page').forEach(p => p.classList.remove('active'));
  document.querySelectorAll('.nav-item').forEach(n => n.classList.remove('active'));
  document.getElementById('page-' + name).classList.add('active');
  event.currentTarget.classList.add('active');
  if (name === 'qimages') renderQuestionImages();
}

// ?? Toast ?????????????????????????????????????????????????????????????????????
function toast(msg) {
  const el = document.getElementById('toast');
  el.textContent = msg;
  el.classList.add('show');
  setTimeout(() => el.classList.remove('show'), 2500);
}

// ?? Init ??????????????????????????????????????????????????????????????????????

const ADMIN_PW = 'fresch2024';
let adminUnlocked = false;

function exitAdmin() {
  const adminView = document.getElementById('adminView');
  const finderView = document.getElementById('finderView');
  if (adminView) adminView.classList.remove('active');
  if (finderView) finderView.style.display = '';
  adminUnlocked = false;
  history.replaceState(null, '', window.location.pathname);
  loadLiveDB().then(() => {
    if (!DB_LIVE || !DB_LIVE.length) DB_LIVE = DB.map(c => ({...c}));
    renderAll();
  });
}


/* ???? COMBINED INIT ???? */
function isAdminMode() {
  return window.location.search.includes('admin');
}

function showAdminLogin() {
  const overlay = document.getElementById('adminLoginOverlay');
  if (overlay) overlay.style.display = 'flex';
}

function tryAdminLogin() {
  const pw = document.getElementById('adminPwInput').value;
  if (pw === ADMIN_PW) {
    adminUnlocked = true;
    const overlay = document.getElementById('adminLoginOverlay');
    const adminView = document.getElementById('adminView');
    const finderView = document.getElementById('finderView');
    if (overlay) overlay.style.display = 'none';
    if (adminView) adminView.classList.add('active');
    if (finderView) finderView.style.display = 'none';
    loadDB();
  } else {
    const errEl = document.getElementById('adminPwError');
    const pwEl = document.getElementById('adminPwInput');
    if (errEl) errEl.style.display = 'block';
    if (pwEl) { pwEl.value = ''; pwEl.focus(); }
  }
}

document.addEventListener('keydown', e => {
  if (e.key === 'Escape') { closeSteckbrief(); }
  if (e.key === 'Enter' && document.getElementById('adminLoginOverlay') &&
      document.getElementById('adminLoginOverlay').style.display === 'flex') {
    tryAdminLogin();
  }
});

function exportUpdatedHTML() {
  const currentHTML = document.documentElement.outerHTML;
  const dbStr = JSON.stringify(DB);
  let updated = currentHTML.replace(
    /const DB=\[.*?\];/s,
    'const DB=' + dbStr + ';'
  );
  const blob = new Blob([updated], {type: 'text/html'});
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = 'fresch-print-finder-admin.html';
  a.click();
  toast('ok HTML exportiert!');
}

/* ?? Startup ?? */
window.addEventListener('resize', () => {
  if(document.getElementById('sOverview')?.classList.contains('on')) filterOverview();
});

window.addEventListener('DOMContentLoaded', async () => {
  const hide = id => { const el = document.getElementById(id); if(el) el.style.display = 'none'; };
  const show = (id, v='') => { const el = document.getElementById(id); if(el) el.style.display = v; };

  if (isAdminMode()) {
    showAdminLogin();
  } else {
    hide('adminView');
    hide('adminLoginOverlay');
    try {
      await loadLiveDB();
    } catch(e) {}
    if (!DB_LIVE || !DB_LIVE.length) DB_LIVE = DB.map(c => ({...c}));
    renderAll();
  }
});